import axios from "./http";
import * as apis from "@/api/apis.js";
import QRCode from "qrcode";
import html2canvas from "html2canvas";
let baseUrl = "";

export function getHuozhuLastPici(params) {
	return axios.post(`${baseUrl}/syapi/Huozhu/getHuozhuLastPici`, params);
}
export function getZaishouAndShouwanPiciData(params) {
	return axios.post(`${baseUrl}/syapi/pici/getZaishouAndShouwanPiciData`, params);
}
export function simpleGoodsListByPici(params) {
	return axios.post(`${baseUrl}/syapi/goods/simpleGoodsListByPici`, params);
}
export function get_web_version(params) {
	return axios.post(`${baseUrl}/api/apk/get_web_version`, params);
}





export function register(params) {
	return axios.post(`${baseUrl}/syapi/center/addPadUser`, params);
}

// api/index.js 或 api/sale.js
export function exportDutyDetailExcel(params) {
  return axios.post(
    `${baseUrl}/syapi/Sale/exportDutyDetailExcel`,
    params,
    {
      responseType: "blob",     // ✅ 必须：拿文件流
    }
  );
}




export function getProductList(params) {
	return axios.post(`${baseUrl}/syapi/goods/lists`, params);
}
//登录
export function login(params) {
	return axios.post(`${baseUrl}/syapi/cashier/login`, params);
}
//获取测试账号
export function accountTest(params) {
	return axios.post(`${baseUrl}/syapi/cashier/accountTest`, params);
}
//获取货品所有分类
export function allCategory(params) {
	return axios.post(`${baseUrl}/syapi/category/lists`, params);
}

//获取货品所有分类
export function allCategoryCloud(params) {
	return axios.post(`${baseUrl}/syapi/category/adminLists`, params);
}

//获取货品所有一级分类
export function categoryone(params) {
	return axios.post(`${baseUrl}/syapi/category/categoryone`, params);
}
//获取货品所有二级分类
export function categorytwo(params) {
	return axios.post(`${baseUrl}/syapi/category/categorytwo`, params);
}

//获取货品所有一级分类
export function categoryoneCloud(params) {
	return axios.post(`${baseUrl}/syapi/category/categoryoneCloud`, params);
}
//获取货品所有二级分类
export function categorytwoCloud(params) {
	return axios.post(`${baseUrl}/syapi/category/categorytwoCloud`, params);
}

//获取货品所有分类
export function updateSelfStatus(params) {
	return axios.post(`${baseUrl}/syapi/goods/updateSelfStatus`, params);
}
export function getSelfKeywords(params) {
	return axios.post(`${baseUrl}/syapi/goods/getSelfKeywords`, params);
}
export function getCloudKeywords(params) {
	return axios.post(`${baseUrl}/syapi/goods/getCloudKeywords`, params);
}
//获取货品所有分类
export function getInventoryListData(params) {
	return axios.post(`${baseUrl}/syapi/goods/getInventoryListData`, params);
}

//获取货品所有分类
export function handPayment(params) {
	return axios.post(`${baseUrl}/syapi/goods/handPayment`, params);
}

//获取货品所有分类
export function categoryListsSelf(params) {
	return axios.post(`${baseUrl}/syapi/category/lists`, params);
}

//添加货品分类
export function addCategory(params) {
	return axios.post(`${baseUrl}/syapi/category/add`, params);
}
//获取订单列表
export function getOrderList(params) {
	return axios.post(`${baseUrl}/syapi/order/lists`, params);
}
//获取当前分类下的货品
export function getCategoryGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/lists`, params);
}
//获取当前分类下的货品
export function goods_lists(params) {
	return axios.post(`${baseUrl}/syapi/goods/goods_lists`, params);
}

export function getGoodsList(params) {
	return axios.post(`${baseUrl}/syapi/goods/goodslists`, params);
}

//获取当前分类下的货品
export function getSelfCategoryGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/getSelfCategoryGoods`, params);
}
export function getPiciInfo(params) {
	return axios.post(`${baseUrl}/syapi/pici/getPiciInfo`, params);
}
export function updatePici(params) {
	return axios.post(`${baseUrl}/syapi/pici/updatePici`, params);
}
//获取当前分类下的货品
export function getCloudCategoryGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/getCloudCategoryGoods`, params);
}
//获取当前分类下的货品
export function cloudToSelf(params) {
	return axios.post(`${baseUrl}/syapi/goods/cloudToSelf`, params);
}
//获取当前分类下的货品
export function pingdanLog(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/pingdanLog`, params);
}

export function getGoodsHistoryPrice(params) {
	return axios.post(`${baseUrl}/syapi/goods/historyPrice`, params);
}

export function kaidanDataCar(params) {
	return axios.post(`${baseUrl}/syapi/order/kaidanDataCar`, params);
}

export function getLastOrder(params) {
	return axios.post(`${baseUrl}/syapi/order/getLastOrder`, params);
}

export function dataCar(params) {
	return axios.post(`${baseUrl}/syapi/order/dataCar`, params);
}
export function deleteCar(params) {
	return axios.post(`${baseUrl}/syapi/order/deleteCar`, params);
}
export function addHuozhuData(params) {
	return axios.post(`${baseUrl}/syapi/Huozhu/addHuozhuData`, params);
}
export function getAllHuozhuData(params) {
	return axios.post(`${baseUrl}/syapi/Huozhu/getAllHuozhuData`, params);
}
export function addPiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/addPiciData`, params);
}
export function getAllPiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/getAllPiciData`, params);
}
export function getUnitData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/getUnitData`, params);
}
export function delHuozhuData(params) {
	return axios.post(`${baseUrl}/syapi/huozhu/delHuozhuData`, params);
}
export function delPiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/delPiciData`, params);
}
export function updatePiciData(params) {
	return axios.post(`${baseUrl}/syapi/Pici/updatePiciData`, params);
}
export function extendUnitData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/extendUnitData`, params);
}
export function updateUnitData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/updateUnitData`, params);
}

export function extendUnitDelData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/extendUnitDelData`, params);
}
export function updateGuigeData(params) {
	return axios.post(`${baseUrl}/syapi/Goods/updateGuigeData`, params);
}

export function addMaijiaCar(params) {
	return axios.post(`${baseUrl}/syapi/order/addMaijiaCar`, params);
}
export function getMaijiaCar(params) {
	return axios.post(`${baseUrl}/syapi/order/getMaijiaCar`, params);
}
export function addmj(params) {
	return axios.post(`${baseUrl}/syapi/order/addmj`, params);
}
export function addOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/addOrderData`, params);
}

//查询会员信息
export function getMemberInfo(params) {
	return axios.post(`${baseUrl}/syapi/member/searcheShouyinMember`, params);
}

//查询会员信息
export function getBindMemberInfo(params) {
	return axios.post(`${baseUrl}/syapi/member/searcheShouyinBindMember`, params);
}

//查询会员信息
export function getMember(params) {
	return axios.post(`${baseUrl}/syapi/order/getMember`, params);
}
// 删除货品分类
export function getdelInfo(params) {
	return axios.post(`${baseUrl}/syapi/category/del`, params);
}
// 编辑货品分类
export function getedcategoryInfo(params) {
	return axios.post(`${baseUrl}/syapi/category/edcategory`, params);
}
//删除货品
export function delGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/delGoods`, params);
}
//添加货品
export function addGoods(params) {
	return axios.post(`${baseUrl}/syapi/goods/add`, params);
}
//添加货品
export function exportGoodsData(params) {
	return axios.post(`${baseUrl}/syapi/goods/exportGoodsData`, params);
}

//添加货品
export function addSelf(params) {
	return axios.post(`${baseUrl}/syapi/goods/addSelf`, params);
}
//获取货品规格项
export function getGoodsSpec(params) {
	return axios.get(`${baseUrl}/syapi/goods/goodsspec`, params);
}

// 编辑货品保存
export function updateGoodsInfo(params) {
	return axios.post(`${baseUrl}/syapi/goods/editsave`, params);
}

// 修改货品分类
export function updateGoodsType(params) {
	return axios.post(`${baseUrl}/syapi/goods/edcategory`, params);
}
//修改货品分类
export function changeCategray(params) {
	return axios.post(`${baseUrl}/syapi/category/ed`, params);
}
//获取订单详情
export function getOrderDetailData(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderDetailData`, params);
}

//获取订单详情
export function getOrderDetailPrint(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderDetailPrint`, params);
}
//获取订单详情
export function getOrderPrint(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderPrint`, params);
}

//获取订单详情
export function getOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderData`, params);
}

export function getOrderByOrderIdData(params) {
	return axios.post(`${baseUrl}/syapi/order/getOrderByOrderIdData`, params);
}

//作废订单
export function zuofeiOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/zuofeiOrderData`, params);
}
//修改订单
export function updateOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/updateOrderData`, params);
}

//作废订单
export function getZuofeiOrderDetailData(params) {
	return axios.post(`${baseUrl}/syapi/order/getZuofeiOrderDetailData`, params);
}

//挂单数据
export function getMaijiaCarqudan(params) {
	return axios.post(`${baseUrl}/syapi/order/getMaijiaCarqudan`, params);
}

//挂单操作
export function guadanData(params) {
	return axios.post(`${baseUrl}/syapi/order/guadanData`, params);
}
//批量改价获取数据
export function updateData(params) {
	return axios.post(`${baseUrl}/syapi/order/updateData`, params);
}

//批量改价获取数据
export function fenjianData(params) {
	return axios.post(`${baseUrl}/syapi/order/fenjianData`, params);
}
//批量改价提交数据
export function updatePriceData(params) {
	return axios.post(`${baseUrl}/syapi/order/updatePriceData`, params);
}

//挂单回购物车
export function guadantocar(params) {
	return axios.post(`${baseUrl}/syapi/order/guadantocar`, params);
}
//挂单回购物车
export function addHuozhuDataShangpin(params) {
	return axios.post(`${baseUrl}/syapi/huozhu/addHuozhuDataShangpin`, params);
}
//挂单回购物车
export function addPiciDataShangpin(params) {
	return axios.post(`${baseUrl}/syapi/pici/addPiciDataShangpin`, params);
}
//挂单回购物车
export function getUserInfo(params) {
	return axios.post(`${baseUrl}/syapi/member/getUserInfo`, params);
}
// 修改用户信息
export function updateUserInfo(params) {
	return axios.post(`${baseUrl}/syapi/member/updateUserInfo`, params);
}
//查看账期
export function lookBookData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/lookBookData`, params);
}
//查看交班数据
export function getStatisticsData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/getStatisticsData`, params);
}
//添加支出项目
export function addZhichuData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addZhichuData`, params);
}
//添加批次支出项目
export function addPiciZhichuData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addPiciZhichuData`, params);
}
//获取所有的费用项
export function getAllFeiyongxiangData(params) {
	return axios.post(
		`${baseUrl}/syapi/Statistics/getAllFeiyongxiangData`,
		params
	);
}
//添加费用项
export function addFeiyongxiangData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addFeiyongxiangData`, params);
}
//删除费用项
export function delFeiyongxiangData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/delFeiyongxiangData`, params);
}

//获取统计页面的订单
export function getStatisticsOrderData(params) {
	return axios.post(
		`${baseUrl}/syapi/Statistics/getStatisticsOrderData`,
		params
	);
}
//获取统计页面的订单
export function jiaozhangData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/jiaozhangData`, params);
}
//获取支出数据
export function getZhichuOrderData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/getZhichuOrderData`, params);
}
//删除支出数据
export function deleteZhichuData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/deleteZhichuData`, params);
}
//还款数据
export function huankuanData(params) {
	return axios.post(`${baseUrl}/syapi/order/huankuanData`, params);
}
//查看统计的支付类型数据
export function lookPayTypeOrderData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/lookPayTypeOrderData`, params);
}
//查看统计的支付类型数据
export function getHuankuanData(params) {
	return axios.post(`${baseUrl}/syapi/order/getHuankuanData`, params);
}
//查看统计的支付类型数据
export function lookHuankuanOrderDetailData(params) {
	return axios.post(
		`${baseUrl}/syapi/order/lookHuankuanOrderDetailData`,
		params
	);
}

//打印拆单数据
export function orderGetPrintOrder(params) {
	return axios.post(`${baseUrl}/syapi/order/orderGetPrintOrder`, params);
}

//撤销还款订单
export function revokeOrderData(params) {
	return axios.post(`${baseUrl}/syapi/order/revokeOrderData`, params);
}

//还款订单详情
export function getHuankuanDetailData(params) {
	return axios.post(`${baseUrl}/syapi/order/getHuankuanDetailData`, params);
}
//还款订单详情
export function addLuruData(params) {
	return axios.post(`${baseUrl}/syapi/Statistics/addLuruData`, params);
}

//还款订单详情
export function formatData(params) {
	return axios.post(`${baseUrl}/syapi/batch/formatData`, params);
}

//还款订单详情
export function loginout(params) {
	return axios.post(`${baseUrl}/syapi/cashier/loginout`, params);
}



// 飞蛾打印
export function orderListPrint(params) {
	return axios.post(`${baseUrl}/syapi/dayin/orderListPrint`, params);
}
export function orderTestPrint(params) {
	return axios.post(`${baseUrl}/syapi/dayin/orderTestPrint`, params);
}
// 飞蛾打印

//订单退款
export function refund(params) {
	return axios.post(`${baseUrl}/syapi/order/refund`, params);
}

// 批量修改售价
export function updateGoodsPrice(params) {
	return axios.post(`${baseUrl}/syapi/goods/edprice`, params);
}

// 请求规格项
export function getGoodsSpecItem(params) {
	return axios.post(`${baseUrl}/syapi/goods/goodsspecitem`, params);
}
//结算接口
export function orderPay(params) {
	return axios.post(`${baseUrl}/syapi/order/settle`, params);
}

//查询扫描枪的接口
export function saomaFind(params) {
	return axios.post(`${baseUrl}/syapi/goods/scansearch`, params);
}
//轮询接口
export function getPayResult(params) {
	return axios.post(`${baseUrl}/syapi/order/query`, params);
}

//支付

export function payMoney(params) {
	return axios.post(`${baseUrl}/syapi/order/pay`, params);
}
//获取发票

export function getFaPiao(params) {
	return axios.post(`${baseUrl}/syapi/order/fapiao`, params);
}

//平单

export function handPingDan(params) {
	return axios.post(`${baseUrl}/syapi/pici/handPingDan`, params);
}

//发送验证码
export function goSendCode(params) {
	return axios.post(`${baseUrl}/syapi/sms/sendcaptcha`, params);
}
// 获取主题颜色 收款按钮背景色 主题字体颜色
export function getColorConfig() {
	return axios({
		url: `${baseUrl}/syapi/config/color`,
		method: "get"
	});
}
//获取语音
export function getAudio(params) {
	return axios.get(`${baseUrl}/syapi/config/textVoice`, params);
}
//获取第二轮播
export function getmadt(params) {
	return axios.get(`${baseUrl}/syapi/config/secondscreenad`, params);
}
//生成一维码
export function getBarcodegena(params) {
	return axios({
		url: `${baseUrl}/syapi/config/Barcodegena`,
		method: "get",
		// responseType:'blob',
		params
	});
}
// 切换货品上架状态
export function updateSaleStatus(params) {
	return axios.get(
		`${baseUrl}/syapi/goods/updateStatus?ids=${params.ids}&status=${params.status}`,
		params
	);
}
// 获取货品信息
export function getGoodsInfo(params) {
	// return axios.get(`${baseUrl}/syapi/goods/getLabel`, params)
	return axios({
		url: `${baseUrl}/syapi/goods/getLabel`,
		method: "get",
		params
	});
}
// 生成货品条形码
export function getCodeTim(params) {
	return axios({
		url: `${baseUrl}/syapi/goods/saveLabel`,
		method: "get",
		// responseType:'blob',
		params
	});
}
// 获取基本配置
export function getBaseConfig(params) {
	return axios({
		url: `${baseUrl}/syapi/config/config`,
		method: "get",
		params
	});
}
//主屏
export function speakST(val, type) {
	// 检查浏览器是否支持Web Speech API
	const synth = window.speechSynthesis;
	// 创建一个新的SpeechSynthesisUtterance对象
	let text = "";
	// 设置要转换为语音的文本
	if (type) {
		if (type == "wechat") {
			text = `微信支付，收款${val}元`;
		} else if (type == "alipay") {
			text = `支付宝支付，收款${val}元`;
		} else {
			text = `${val}`;
		}
	} else {
		text = `收款成功，收款${val}元`;
	}
	// console.log(text)
	if (window.ttsspeaker) {
		window.ttsspeaker(text);
	} else {
		const speech = new SpeechSynthesisUtterance();
		speech.text = text;
		window.speechSynthesis.speak(speech);
	}
	// // 将文本转换为声音
	// axios.get(`${baseUrl}/syapi/config/textVoice?text=${text}&spd=5`, {
	//   responseType: 'blob'
	// }).then((res) => {
	//   // console.log(res)
	//   // const blob = res
	//   // // 处理下载得到的 Blob 对象
	//   // // 创建 AudioContext 对象
	//   // // 将返回的音频数据（res）封装成一个Blob对象
	//   // const audioBlob = new Blob([res], { type: 'audio/mp3' });
	//   // // 创建audio元素
	//   // const audio = new Audio();
	//   // // const audio = document.createElement('audio'); 也可以替代上面的创建元素方法
	//   // // 通过 createObjectURL 方法将 Blob 对象生成一个音频文件 URL
	//   // audio.src = URL.createObjectURL(audioBlob);
	//   // // 在页面中播放音频
	//   // audio.play();
	//   // // 回收对象URL
	//   // URL.revokeObjectURL(audioUrl);

	//   const blob = res;
	//   const audioBlob = new Blob([blob], { type: 'audio/mp3' });
	//   // 将Blob对象转换成URL对象并设置音频元素的src属性
	//   const audioUrl = URL.createObjectURL(audioBlob);
	//   const audio = document.getElementById('myAudio');
	//   audio.src = audioUrl;
	//   // 播放音频
	//   audio.play();
	//   // URL.revokeObjectURL(audioUrl);
	// }).catch(() => {

	// })
}
export function getGurrentTime() {
	let yy = new Date().getFullYear();
	let mm =
		new Date().getMonth() + 1 < 10
			? "0" + (new Date().getMonth() + 1)
			: new Date().getMonth() + 1;
	let dd =
		new Date().getDate() < 10
			? "0" + new Date().getDate()
			: new Date().getDate();
	let hh =
		new Date().getHours() < 10
			? "0" + new Date().getHours()
			: new Date().getHours();
	let mf =
		new Date().getMinutes() < 10
			? "0" + new Date().getMinutes()
			: new Date().getMinutes();
	let ss =
		new Date().getSeconds() < 10
			? "0" + new Date().getSeconds()
			: new Date().getSeconds();
	return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
}

// 获取当班销售批次
export function getSaleDuty(data) {
	return axios({
		url: `${baseUrl}/syapi/Sale/dutyData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 获取当班销售批次详情
export function getSaleDutyDetail(data) {
	return axios({
		url: `${baseUrl}/syapi/Sale/dutyDetailData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// // 获取班次
// export function getStatistics(data) {
//     return axios({
//         url: `${baseUrl}/syapi/Statistics/lookBookData`,
//         method: "post",
//         // responseType:'blob',
//         data
//     });
// }

// 获取去结算信息
export function getGoSettlementData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goSettlementData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

export function getGoSettlementListData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goSettlementListData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

export function getGoSettlementDetailData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goSettlementDetailData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 获取去结算信息
export function cancelSettlementData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/cancelSettlementData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 获取去结算信息
export function cancelPayData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/cancelPayData`,
		method: "post",
		// responseType:'blob',
		data
	});
}
// 销售明细
export function saleDetailListData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/saleDetailListData`,
		method: "post",
		data
	});
}

// 确认结算
export function handelSettlementData(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/handelSettlementData`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库暂存列表
export function goodsStoreCountStagingList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountStagingList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库暂存操作
export function goodsStoreCountStaging(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountStaging`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库操作
export function goodsStoreCount(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCount`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 删除入库暂存
export function delGoodsStoreCountStaging(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountStagingDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 入库暂存修改
export function goodsUpdateStaging(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdateStaging`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点暂存列表
export function goodsStoreCountPandianList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountPandianList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点暂存操作
export function goodsStoreCountPandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountPandian`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点操作
export function goodsPandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsPandian`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 删除盘点暂存
export function delGoodsStoreCountPandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountPandianDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 盘点暂存修改
export function goodsUpdatePandian(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdatePandian`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出暂存列表
export function goodsStoreCountOutList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountOutList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出暂存操作
export function goodsStoreCountOut(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountOut`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 删除调出暂存
export function delGoodsStoreCountDiaochu(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountOutDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出操作
export function goodsOut(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsOut`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出暂存修改
export function goodsUpdateOut(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdateOut`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 报损暂存列表
export function goodsStoreCountLossesList(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountLossesList`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 报损暂存操作
export function goodsStoreCountLosses(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountLosses`,
		method: "post",
		// responseType:'blob',
		data
	});
}
export function getDevice() {
	return navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	);
}

export function keyboardSpeak(text) {
	  // return true;

	let flag = getDevice();
	if (flag) {
		let flag_type = flag[0] ? flag[0] : "Android";

		if (flag_type == "Android") {
			// 安卓设备
			//调取斯普瑞特打印机

			let printer_info = JSON.parse(localStorage.getItem("printer_info"));

			if (printer_info.keyboard_speaker) {

				// window.Android.setSpeaker(2);//这里面的
				window.Android.speakText(
					text,
					printer_info.speaker_speed,
					printer_info.speaker_pitch,
					printer_info.speaker_volume
				); //语速 音量 语调
			}
		}
	}
}

export function speak(text) {
	  // return true;

	let flag = getDevice();
	if (flag) {
		let flag_type = flag[0] ? flag[0] : "Android";



		if (flag_type == "Android") {
			// 安卓设备
			//调取斯普瑞特打印机

			let printer_info = JSON.parse(localStorage.getItem("printer_info"));

			if (printer_info.speaker) {

				// window.Android.setSpeaker(2);//这里面的
				window.Android.speakText(
					text,
					printer_info.speaker_speed,
					printer_info.speaker_pitch,
					printer_info.speaker_volume
				); //语速 音量 语调
			}
		}
	}
}

export function activeBaiduCode() {
	let flag = getDevice();
	if (flag) {
		let flag_type = flag[0] ? flag[0] : "Android";
		if (flag_type == "Android") {
			// 安卓设备
			window.Android.activateBaidu();
		}
	}
}

function isAndroidEnv() {
  try {
    var nav = (typeof navigator !== 'undefined') ? navigator : undefined;
    var w   = (typeof window !== 'undefined') ? window : undefined;
    var uaIsAndroid = !!(nav && /Android/i.test(nav.userAgent));
    var hasBridge   = !!(w && w.Android);
    return uaIsAndroid || hasBridge;
  } catch (e) {
    return false;
  }
}

export function playAudioFromAssets(item) {

	if (!isAndroidEnv()) return;
	let flag = getDevice();
	if (flag) {
		let flag_type = flag[0] ? flag[0] : "Android";
		if (flag_type == "Android") {
			// 安卓设备
			let printer_info = JSON.parse(localStorage.getItem("printer_info"));
			// alert(printer_info.keyboard_speaker)
			if (printer_info.keyboard_speaker) {
				let filename = "";
				if (item == "+") {
					filename = "yunyangneural_jia.mp3";
				} else if (item == "-") {
					filename = "yunyangneural_jian.mp3";
				} else if (item == "x") {
					filename = "yunyangneural_cheng.mp3";
				} else if (item == ".") {
					filename = "yunyangneural_dian.mp3";
				} else if (item == "下一项") {
					filename = "yunyangneural_xiayixiang.mp3";
				} else if (item == "删除") {
					filename = "yunyangneural_tuiwei.mp3";
				} else {
					filename = "yunyangneural_" + item + ".mp3";
				}

				window.Android.playAudioFromAssets(filename);
			}
		}
	}
}

export function fenjian_sprt_printer(item) {
	// window.Android
	let pay_str = "";
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	const num = 0;

	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "-配货单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 0, 0);
	window.Android.pSetPrinter(13, 0); //

	window.Android.pPrintText("买家:" + item.name + "\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pSetFont(0, 0, 1, 0, 0);
	window.Android.pPrintText("品名                 订购                 实际\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	let order_detail = item.order_car;
	for (let i = 0; i < order_detail.length; i++) {
		window.Android.pSetFont(0, 0, 1, 1, 0);
		//判断字符的长度
		let len = order_detail[i].goods_name.length;
		let goods_name = i + 1 + "." + order_detail[i].goods_name;
		for (let i = 0; i < 19 - len * 2; i++) {
			goods_name = goods_name + " ";
		}
		let show_num = order_detail[i].weight
			? order_detail[i].weight
			: order_detail[i].num;
		let show_unit = order_detail[i].unit;
		if (show_unit.length == 1) {
			show_unit = order_detail[i].unit + "  ";
		}
		// if (show_unit.length == 2) {
		// 	show_unit = order_detail[i].unit + "    ";
		// }
		let goods_info = "";
		window.Android.pSetPrinter(13, 0); //

		goods_info = goods_info + goods_name;

		goods_info = goods_info + show_num + show_unit + "        ";

		window.Android.pPrintText(goods_info + "\n");

		window.Android.pSetFont(0, 0, 0, 1, 0);
		window.Android.pSetPrinter(13, 0); //

		if (order_detail[i].pici) {
			window.Android.pPrintText(
				order_detail[i].pici.huozhu_name +
					"-" +
					order_detail[i].pici.pici +
					"\n"
			);
		}

		window.Android.pSetPrinter(13, 0); //
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);
	window.Android.pSetFont(0, 0, 1, 1, 0);

	window.Android.pPrintText("总数量:" + item.total_num + "\n");

	window.Android.pSetFont(0, 0, 0, 1, 0);
	window.Android.pPrintText(
		"打印员:" + item.user.name + " 打印时间:" + getGurrentTime() + "\n"
	);

	for (let i = 0; i < num; i++) {
		window.Android.pPrintText("\n");
	}
	window.Android.pCutPaper(65, 50);
}
function charWidth(ch) { return /[^\x00-\x7F]/.test(ch) ? 2 : 1; }   // 非ASCII按2宽
function textWidth(str) {
    if (!str) return 0;
    let w = 0; for (const ch of String(str)) w += charWidth(ch);
    return w;
  }
  // 按宽截断（中=2/英=1），超出则尾部加省略号 …
function sliceToWidth(str, maxW) {
    if (!str) return "";
    let w = 0, out = "";
    for (const ch of String(str)) {
      const cw = charWidth(ch);
      if (w + cw > maxW) break;
      out += ch; w += cw;
    }
    if (textWidth(str) > maxW && maxW >= 2) {
      while (textWidth(out) > maxW - 2) out = out.slice(0, -1);
      out += "…";
    }
    return out;
  }
  function padRight(str, width) { let s = String(str||""); while (textWidth(s) < width) s += " "; return s; }
  function padLeft (str, width) { let s = String(str||""); while (textWidth(s) < width) s = " " + s; return s; }

  // 只统计汉字数量
  function countHanzi(str){ return (String(str).match(/[\u4e00-\u9fa5]/g) || []).length; }
  // 截取前 n 个汉字（忽略非汉字），并加 …
  function cutHanzi(str, n){
    const m = String(str).match(/[\u4e00-\u9fa5]/g) || [];
    const needEllipsis = m.length > n;
    const cut = m.slice(0, n).join("");
    return needEllipsis ? (cut + "…") : cut;
  }

//主屏
export function sprt_printer(item) {

  // ========= 宽度&对齐工具 =========
  const COLS_TOTAL = 48;
  const COLS_NAME  = 15;
  const COLS_QTY   = 15;
  const COLS_PRICE = 9;
  const COLS_AMT   = 9;
	const COLS_STATUS = 24;
	const COLS_PIAONUM = 24;
	const TOTAL_TOP = 24;
	// 判空：undefined/null/空字符串/全空白 => true
const isBlank = v => {
  if (v == null) return true;                 // null / undefined
  const s = String(v).trim();
  if (s === "") return true;                  // 空字串
  if (!isNaN(s) && Number(s) === 0) return true; // 數值為 0 / 0.0 / 0.00
  return false;
};
  // ========= 你原有的状态判断 =========
  let pay_status = "";
  if (item.yingshou <= 0) {
    pay_status = "已付款";
  } else {
    if (item.yingshou == item.shishou) pay_status = "未付款";
    else pay_status = "赊欠";
  }
  if (item.status == 1) pay_status = "已付款";

  const userinfo = JSON.parse(localStorage.getItem("userInfo"));
  const printer_info = JSON.parse(localStorage.getItem("printer_info"));
  window.Android.pSetFont(0, 1, 1, 0, 0);
  window.Android.pSetPrinter(13, 0);

  // 票号 & 状态（保持你的风格）
 const leftText  = isFieldChecked("header","order_status") ? (pay_status || "")    : "";
 const rightText = isFieldChecked("header","piao_num")     ? (item.piao_num || "") : "";

 // 右侧先定宽，左侧根据剩余宽度截断，最后中间补空格
 const R   = sliceToWidth(rightText, TOTAL_TOP);
 const maxL= Math.max(0, TOTAL_TOP - textWidth(R));
 const L   = sliceToWidth(leftText, maxL);
 const gap = TOTAL_TOP - textWidth(L) - textWidth(R);

 if (textWidth(L) + textWidth(R) > 0) {
   window.Android.pPrintText(L + " ".repeat(gap) + R + "\n");
 }

  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pSetPrinter(13, 2);
  if (isFieldChecked("header","cashier_id")) {
    window.Android.pPrintText("操作员:" + item.user.name + "\n");
  }

  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 0, 0, 1, 0);
  window.Android.pSetPrinter(13, 1);
  if (isFieldChecked("header","deal_address")) {
    window.Android.pPrintText(userinfo.area + "\n");
  }

  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 1, 1, 1, 0);
  window.Android.pSetPrinter(13, 1);
  if (isFieldChecked("header","voucher")) {
    window.Android.pPrintText(userinfo.dangkou_name + "-销售凭证\n");
  }

  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 1, 1, 0, 0);
  window.Android.pSetPrinter(13, 0);
  if (isFieldChecked("header","maijia")) {
    window.Android.pPrintText("买家:" + item.maijia + "\n");
  }

  // 表头用同列宽生成，确保对齐
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------------------------------------\n");
  window.Android.pSetFont(0, 0, 1, 0, 0);
  {
    const hName  = padRight(sliceToWidth("品名", COLS_NAME),  COLS_NAME);
    const hQty   = padLeft ("数量", COLS_QTY);
    const hPrice = padLeft ("单价", COLS_PRICE);
    const hAmt   = padLeft ("货款", COLS_AMT);
    window.Android.pPrintText(hName + hQty + hPrice + hAmt + "\n");
  }
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------------------------------------\n");

  // ========= 明细行 =========
  const order_detail = item.order_detail || [];
  for (let i = 0; i < order_detail.length; i++) {
    const od = order_detail[i];

    // 品名：汉字>7先按汉字截（加…），再整体按20列宽渲染
    const baseName = od.goods_name || "海南大香蕉";
    const nameAfterHanziRule = countHanzi(baseName) > 7 ? cutHanzi(baseName, 7) : baseName;
    const listedName = (i + 1) + "." + nameAfterHanziRule;
    const nameCol = padRight(sliceToWidth(listedName, COLS_NAME), COLS_NAME);

    // 数量：weight 优先，否则 num；单位过长会截到最多4列宽；整体右对齐到10列
    const showNum = (od.show_num_weight ? od.show_num_weight : "");
    let unit = od.unit || "";
    unit = sliceToWidth(unit, 4);
    const qtyStr = sliceToWidth(String(showNum), COLS_QTY);
    const qtyCol = padLeft(qtyStr, COLS_QTY);

    // 单价：有(包)前缀则尽量保留，但不超出列宽；右对齐到9列
    let priceStr = String(od.price ?od.price: "");
    if (od.huozhu_num > 0) priceStr = "(包)" + priceStr;
    priceStr = sliceToWidth(priceStr, COLS_PRICE);
    const priceCol = padLeft(priceStr, COLS_PRICE);

    // 货款：右对齐到9列
    const amtStr = sliceToWidth(String(od.goods_price ?od.goods_price : ""), COLS_AMT);
    const amtCol = padLeft(amtStr, COLS_AMT);

    let line = nameCol + qtyCol + priceCol + amtCol;
    // 兜底，确保正好48列
    const w = textWidth(line);
    if (w < COLS_TOTAL) line += " ".repeat(COLS_TOTAL - w);
    else if (w > COLS_TOTAL) line = sliceToWidth(line, COLS_TOTAL);

    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pSetPrinter(13, 0);
    // 按字段开关显示（用列串替换你原来的拼空格）
    let finalLine = "";
    if (isFieldChecked("goods", "goods_name")) finalLine += nameCol; else finalLine += padRight("--", COLS_NAME);
    if (isFieldChecked("goods", "goods_shuliang")) finalLine += qtyCol; else finalLine += padLeft("--", COLS_QTY);
    if (isFieldChecked("goods", "goods_danjia")) finalLine += priceCol; else finalLine += padLeft("--", COLS_PRICE);
    if (isFieldChecked("goods", "goods_jiage")) finalLine += amtCol; else finalLine += padLeft("--", COLS_AMT);

    window.Android.pPrintText(finalLine + "\n");

    // 批次
    window.Android.pSetFont(0, 0, 0, 1, 0);
    window.Android.pSetPrinter(13, 0);
    if (isFieldChecked("goods", "huozhupici") && od.order_detail_pici) {
      window.Android.pPrintText(od.order_detail_pici.huozhu_name + "-" + od.order_detail_pici.pici + "\n");
    }

    // 附加费
    const order_detail_fujiafei = od.order_detail_fujiafei || [];
    let str = "";
    for (let j = 0; j < order_detail_fujiafei.length; j++) {
      const fj = order_detail_fujiafei[j];
      if (fj.total) {
        printer_info.field.goods.forEach(conf => {
          if (conf.extend === "fujiafei" && conf.checked && conf.field_name === fj.name) {
            str += `${fj.name}:${fj.total}元 `;
          }
        });
      }
    }
    if (str) window.Android.pPrintText("附加费:(" + str + ")\n");

    // 小计
    window.Android.pSetFont(0, 0, 1, 1, 0);
    printer_info.field.goods.forEach(conf => {
      if (conf.field_name === "goods_total" && conf.checked) {
        window.Android.pSetPrinter(13, 2);
        window.Android.pPrintText("小计:" + od.total_price + "元\n");
      }
    });
    window.Android.pSetPrinter(13, 0);
  }

  // ========= 合计/结算区（保持你的逻辑） =========
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------------------------------------\n");
  window.Android.pSetFont(0, 0, 1, 1, 0);

  if (printer_info.field.settle[0].checked) {
    window.Android.pSetPrinter(13, 0);
    let youhui = "";
    if (item.youhui > 0) youhui = "优惠:" + item.youhui + "元";
    if (item.duoshou > 0) youhui = "多收:" + item.duoshou + "元";

    if (item.huankuan) {
      window.Android.pPrintText("总计:" + (item.yingshou + item.shishou) + "元\n");
      window.Android.pPrintText("本次还款:" + item.huankuan.money + "\n");
      if (item.huan > item.huankuan.money) window.Android.pPrintText("累计还款:" + item.huan + "\n");
      window.Android.pPrintText("下欠:" + item.yingshou + "元\n");
    } else {
      window.Android.pPrintText("总计:" + item.total_price + "元\n");
      if (youhui) window.Android.pPrintText(youhui + "\n");
      if (item.huan) window.Android.pPrintText("累计还款:" + item.huan + "元\n");
      if (pay_status === "赊欠") {
        if (item.type != "明细单"){
					window.Android.pPrintText("下欠:" + item.yingshou + "元\n");
				}
      } else {
        window.Android.pPrintText("实收:" + item.shishou + "元\n");
      }
    }
  }

  window.Android.pSetFont(0, 0, 0, 0, 0);
  if (printer_info.field.settle[2].checked && !isBlank(item.notes)) {
    window.Android.pPrintText("备注:" + String(item.notes).trim() + "\n");
  }

  if (printer_info.field.settle[3].checked && item.sheqian > 0) {
    window.Android.pPrintText("截止到:" + getGurrentTime() + "\n");
    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pPrintText("赊欠总额:" + item.sheqian + "元\n");
  }

  window.Android.pSetFont(0, 0, 0, 0, 0);
  if (printer_info.field.settle[4].checked) window.Android.pPrintText("开单时间:" + item.add_time + "\n");
  if (printer_info.field.settle[5].checked) window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

  let pays = [];
  if (!isBlank(item.cash_num))   pays.push(" 现金:"   + item.cash_num);
  if (!isBlank(item.wepay_num))  pays.push(" 微信:"   + item.wepay_num);
  if (!isBlank(item.alipay_num)) pays.push(" 支付宝:" + item.alipay_num);
  if (!isBlank(item.union_num))  pays.push(" 银联:"   + item.union_num);
  if (!isBlank(item.other_num))  pays.push(" 其他:"   + item.other_num);

  const pay_str = pays.join("");
  if (printer_info.field.pay[0].checked && !isBlank(pay_str)) {
    window.Android.pPrintText("支付方式:" + pay_str + "\n");
  }

  if (printer_info.field.other[0].checked) window.Android.pPrintText("档口电话:" + userinfo.dangkou_phone + "\n");
  if (printer_info.field.other[1].checked) window.Android.pPrintText("档口地址:" + userinfo.dangkou_address + "\n");
 if (printer_info.field.other[1].checked) {
   // 先对齐到你需要的位置（可选）
   window.Android.pSetPrinter(13, 1);

   // 打印条码/二维码
   window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link?printer_info.shoukuan_link:"https://work.weixin.qq.com/u/vc3b1be9d42e188133", "gbk");

   // 重新设定字体/对齐（有些机型在图形模式后需要再设一次）
   window.Android.pSetFont(0, 0, 0, 0, 0);
   window.Android.pSetPrinter(13, 1);
    var msg =  printer_info.shoukuan_link_text ? printer_info.shoukuan_link_text : ("扫码咨询免费试用云批宝");
    window.Android.pPrintText(msg+"\n");
 }
		// window.Android.pPrintText("1111\n");

  window.Android.pCutPaper(65, 50);
  apis.print_history();
}

  export function sheqian_printer(list, total_price, total_num) {
    // ===== 列宽（总宽=48）→ 全部右对齐 =====
    const COLS_TOTAL = 48;
    const COLS_SEQ   = 4;  // 序号
    const COLS_BUYER = 18;  // 买家（改为20，让列宽之和=48）
    const COLS_CNT   = 14;   // 单数
    const COLS_AMT   = 12;  // 金额

    // 工具：若你项目已有这些方法，保留你自己的即可
    const _hasLineEnds = typeof lineEnds === "function";
    function _lineEnds(line, width) {
      if (_hasLineEnds) return lineEnds(line, width);
      const w = textWidth(line);
      if (w === width) return line;
      if (w < width) return line + " ".repeat(width - w);
      return sliceToWidth(line, width);
    }
    const isBlank = v => v == null || String(v).trim() === "";
    function normalizeDigits(s) {
      if (s == null) return "";
      return String(s).replace(/[٠-٩]/g, ch => "٠١٢٣٤٥٦٧٨٩".indexOf(ch));
    }

    const userinfo     = JSON.parse(localStorage.getItem("userInfo")     || "{}");
    const printer_info = JSON.parse(localStorage.getItem("printer_info") || "{}");

    // ===== 抬头（保持你的原逻辑）=====
    window.Android.pSetFont(0, 1, 1, 0, 0);
    window.Android.pSetPrinter(13, 0);
    window.Android.pSetFont(0, 0, 0, 1, 0);
    window.Android.pSetPrinter(13, 1);
    if (isFieldChecked("header", "deal_address") && userinfo.area) {
      window.Android.pPrintText(userinfo.area + "\n");
    }
    window.Android.pPrintText("\n");
    window.Android.pSetFont(0, 1, 1, 1, 0);
    window.Android.pSetPrinter(13, 1);
    if (isFieldChecked("header", "voucher")) {
      window.Android.pPrintText((userinfo.dangkou_name || "") + "-赊欠总览\n");
    }
    window.Android.pPrintText("\n");

    // ===== 表格：统一字体 =====
    window.Android.pSetFont(0, 0, 0, 0, 0);
    window.Android.pSetPrinter(13, 0);

    window.Android.pPrintText("-".repeat(48) + "\n");

    // 表头 → 全部右对齐（padLeft）
    const hSeq   = padLeft(sliceToWidth("序号", COLS_SEQ),   COLS_SEQ);
    const hBuyer = padLeft(sliceToWidth("买家", COLS_BUYER), COLS_BUYER);
    const hCnt   = padLeft(sliceToWidth("单数", COLS_CNT),   COLS_CNT);
    const hAmt   = padLeft(sliceToWidth("金额", COLS_AMT),   COLS_AMT);
    let header = hSeq + hBuyer + hCnt + hAmt;
    header = _lineEnds(header, COLS_TOTAL);
    window.Android.pPrintText(header + "\n");

    window.Android.pPrintText("-".repeat(48) + "\n");

    // ===== 明细 → 全部右对齐（padLeft）=====
    let seq = 1;
    (list || []).forEach((row) => {
      if (!row || !(row.sheqian_total > 0)) return;

      const seqCol = padLeft(String(seq), COLS_SEQ);

      const buyerRaw = String(row.maijia || "");
      const buyerCol = padLeft(sliceToWidth(normalizeDigits(buyerRaw), COLS_BUYER), COLS_BUYER);

      const cntStr = normalizeDigits(row.no_pay_num || "");
      const cntCol = padLeft(sliceToWidth(cntStr, COLS_CNT), COLS_CNT);

      const amtStr = normalizeDigits(row.sheqian_total || "");
      const amtCol = padLeft(sliceToWidth(amtStr, COLS_AMT), COLS_AMT);

      let line = seqCol + buyerCol + cntCol + amtCol;
      line = _lineEnds(line, COLS_TOTAL);
      window.Android.pPrintText(line + "\n");

      seq++;
    });

    // ===== 总计 =====
    window.Android.pPrintText("====================总计====================\n");
    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pPrintText("总人数:" + (isBlank(total_num) ? "0" : total_num) + "\n");
    window.Android.pPrintText("总赊欠:" + (isBlank(total_price) ? "0" : total_price) + "\n");
    window.Android.pPrintText("\n");

    window.Android.pSetFont(0, 0, 0, 0, 0);
    window.Android.pPrintText("操作人员:" + (userinfo.name || "") + "\n");
    window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

    if (printer_info && printer_info.shoukuan_link) {
      window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link, "gbk");
    }
    window.Android.pCutPaper(65, 50);
  }

export function sprt_print_jiaozhang(statisticsData) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "收银交账单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText(
		"收银人员:" + statisticsData.user._user.name + "\n"
	);
	window.Android.pPrintText("上次交账:" + statisticsData.start_time + "\n");
	window.Android.pPrintText("本次交账:" + statisticsData.end_time + "\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 1, 0, 0);
	window.Android.pPrintText("---------------缴款金额--------------------\n");
	//循环开始
	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pPrintText(
		"当班实收：" + statisticsData.shijiao_total + "元\n"
	);
	window.Android.pSetFont(0, 0, 1, 0, 0);
// 现金
// 现金
{
  const v = statisticsData && statisticsData.cash;
  const s = (v === null || v === undefined) ? '' : String(v).trim();
  const n = Number(s);
  if (s !== '' && Number.isFinite(n) && n !== 0) {
    window.Android && window.Android.pPrintText(`现金：${n}元\n`);
  }
}

// 微信
{
  const v = statisticsData && statisticsData.wepay;
  const s = (v === null || v === undefined) ? '' : String(v).trim();
  const n = Number(s);
  if (s !== '' && Number.isFinite(n) && n !== 0) {
    window.Android && window.Android.pPrintText(`微信：${n}元\n`);
  }
}

// 支付宝
{
  const v = statisticsData && statisticsData.alipay;
  const s = (v === null || v === undefined) ? '' : String(v).trim();
  const n = Number(s);
  if (s !== '' && Number.isFinite(n) && n !== 0) {
    window.Android && window.Android.pPrintText(`支付宝：${n}元\n`);
  }
}

// 银联
{
  const v = statisticsData && statisticsData.union;
  const s = (v === null || v === undefined) ? '' : String(v).trim();
  const n = Number(s);
  if (s !== '' && Number.isFinite(n) && n !== 0) {
    window.Android && window.Android.pPrintText(`银联：${n}元\n`);
  }
}

// 其他
{
  const v = statisticsData && statisticsData.other;
  const s = (v === null || v === undefined) ? '' : String(v).trim();
  const n = Number(s);
  if (s !== '' && Number.isFinite(n) && n !== 0) {
    window.Android && window.Android.pPrintText(`其他：${n}元\n`);
  }
}

	window.Android.pPrintText("---------------账单明细--------------------\n");
	window.Android.pSetFont(0, 0, 1, 1, 0);
	//循环开始
	window.Android.pPrintText("票面总额：" + statisticsData.piaomian + "元\n");
	window.Android.pPrintText(
		"销售货款：" + statisticsData.xiaoshouhuokuan + "元\n"
	);
	window.Android.pPrintText(
		"货款零差：" + statisticsData.huokuanlingcha + "元\n"
	);
	statisticsData.data_detail_fujiafei.forEach((itemdetail, index) => {
		if (itemdetail.total > 0) {
			window.Android.pPrintText(
				itemdetail.name + "：" + itemdetail.total + "元\n"
			);
		}
	});
	if (statisticsData.youhui_total > 0) {
		window.Android.pPrintText("优惠：-" + statisticsData.youhui_total + "元\n");
	}
	if (statisticsData.duoshou_total > 0) {
		window.Android.pPrintText("多收：" + statisticsData.duoshou_total + "元\n");
	}

	window.Android.pPrintText("---------------赊还统计--------------------\n");
	//循环开始
	window.Android.pPrintText(
		"当班赊账：" + statisticsData.dangbansheqian_total + "元\n"
	);
	window.Android.pPrintText(
		"当班还款：" + statisticsData.dangbanhuankuan_total + "元\n"
	);
	window.Android.pPrintText("---------------收支统计--------------------\n");
	//循环开始

	window.Android.pPrintText(
		"收入总额：" + statisticsData.qita_total + "元\n"
	);
	window.Android.pPrintText(
		"支出总额：" + statisticsData.dangbanzhichu_total + "元\n"
	);
	window.Android.pPrintText("---------------单据统计--------------------\n");
	//循环开始
	window.Android.pPrintText(
		"订单数(按货主统计)：" +
			statisticsData.kaipiao_total_num +
			"单(" +
			statisticsData.kaipiao_total_num +
			"单)\n"
	);
	window.Android.pPrintText(
		"开票数：" + statisticsData.kaipiao_total_num + "单\n"
	);
	window.Android.pPrintText("作废订单：" + statisticsData.zuofei_num + "单\n");
	window.Android.pPrintText("修改订单：" + statisticsData.update_num + "单\n");

	window.Android.pCutPaper(66, 50);
}

export function formatLine(col1, col2, col3, col4) {
	// 设置列宽
	const col1Width = 8; // 序号/品名
	const col2Width = 5; // 销量
	const col3Width = 10; // 均价
	const col4Width = 12; // 货款

	col1 = col1.substr(0, col1Width).padEnd(col1Width, " ");

	col2 = String(col2 || "")
		.substr(0, col2Width)
		.padStart(col2Width, " ");
	col3 = String(col3 || "")
		.substr(0, col3Width)
		.padStart(col3Width, " ");
	col4 = String(col4 || "")
		.substr(0, col4Width)
		.padStart(col4Width, " ");

	return col1 + col2 + col3 + col4;
}
 export function sprt_print_pici_toal(selectPici, tableData, statistics) {
   var userinfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
   // var printer_info = JSON.parse(localStorage.getItem("printer_info") || "{}");

   // ===== 打印标题 =====
   window.Android.pPrintText("\n");
   window.Android.pSetFont(0, 1, 1, 1, 0);
   window.Android.pSetPrinter(13, 1);

	 var headerIndex = statistics && typeof statistics.headerIndex !== 'undefined'
	   ? Number(statistics.headerIndex)
	   : 0;

	 var saleStatus = statistics && typeof statistics.saleStatus !== 'undefined'
	   ? Number(statistics.saleStatus)
	   : 0;

	 var title = "批次汇总单"; // 默认

	 if (	saleStatus == 1 && headerIndex == 1) {
	 	   title = "批次全部汇总单";
	 	 } else if (saleStatus == 1 && headerIndex == 2) {
	 			  title = "批次未结全部汇总单";
	 	 } else if (saleStatus == 3 && headerIndex == 2) {
	 	   title = "批次已结全部汇总单";
	 	 }else if (saleStatus == 3 && headerIndex == 1) {
	    title = "批次全部汇总单";
	 	 }



	  window.Android.pPrintText("\n");
	  window.Android.pSetFont(0, 1, 1, 1, 0);
	  window.Android.pSetPrinter(13, 1);
	  window.Android.pPrintText((userinfo.dangkou_name || "") + title + "\n");
	  window.Android.pPrintText("\n");

   window.Android.pSetFont(0, 0, 0, 1, 0);
   window.Android.pSetPrinter(13, 0);
   window.Android.pPrintText(
     "货主：" + (selectPici.huozhu_name || "") +
     "   批次：" + (selectPici.pici || "") + "\n"
   );
   window.Android.pPrintText(
     "时间段：" +
     (statistics.start_time || "") +
     "-" +
     (statistics.end_time || "") +
     "\n"
   );

   window.Android.pSetFont(0, 0, 0, 0, 0);

   // ===== 列宽配置 =====
   var COLS_TOTAL = 48;   // 打印总宽
   var COLS_NAME  = 16;   // 序号/品名
   var COLS_QTY   = 14;   // 销量
   var COLS_PRICE = 10;   // 均价
   var COLS_AMT   = 8;    // 货款（右对齐）

   function line() {
     return new Array(COLS_TOTAL + 1).join("-");
   }

   window.Android.pPrintText(line() + "\n");

   // ===== 表头（严格按列宽对齐） =====
   var hName  = padRight(sliceToWidth("序号/品名", COLS_NAME),  COLS_NAME);
   var hQty   = padRight(sliceToWidth("销量",     COLS_QTY),   COLS_QTY);
   var hPrice = padRight(sliceToWidth("均价",     COLS_PRICE), COLS_PRICE);
   var hAmt   = padLeft (sliceToWidth("货款",     COLS_AMT),   COLS_AMT);

   window.Android.pPrintText(hName + hQty + hPrice + hAmt + "\n");
   window.Android.pPrintText(line() + "\n");

   // ===== 数据行 =====
   // 支持：sell_str = "346件,3460斤"，single = "0.63/件,0.06/公斤"
   // 每个逗号拆成一行，第一行带品名和货款，其它行只展示数量/均价
   tableData.forEach(function (detail, index) {
     var nameBase = (index + 1) + " " + (detail.goods_name || "");
     var sells   = splitParts(detail.sell_str || detail.sell || "");
     var prices  = splitParts(detail.single || "");
     var amtText = detail.all_goods_price != null
       ? String(detail.all_goods_price)
       : "";

     var rows = Math.max(
       sells.length || 1,
       prices.length || 1
     );

     for (var i = 0; i < rows; i++) {
       var nameText  = i === 0 ? nameBase : "";
       var qtyText   = i < sells.length   ? sells[i]   : "";
       var priceText = i < prices.length  ? prices[i]  : "";
       var amtLine   = i === 0 ? amtText : "";

       // 各列截断+填充，保证对齐且不超宽
       var cName  = padRight(sliceToWidth(nameText,  COLS_NAME),  COLS_NAME);
       var cQty   = padRight(sliceToWidth(qtyText,   COLS_QTY),   COLS_QTY);
       var cPrice = padRight(sliceToWidth(priceText, COLS_PRICE), COLS_PRICE);
       var cAmt   = padLeft (sliceToWidth(amtLine,   COLS_AMT),   COLS_AMT);

       window.Android.pPrintText(cName + cQty + cPrice + cAmt + "\n");
     }
   });

   // ===== 汇总行 =====
   window.Android.pSetFont(0, 0, 0, 1, 0);
   window.Android.pPrintText(
     "总件数:" + (statistics.sell_total_num || 0) +
     "   总重量:" + (statistics.sell_total_weight || 0) +
     "   合计:" + (statistics.goods_total || 0) +
     "\n"
   );


	 window.Android.pSetPrinter(13, 1);

	 // 打印条码/二维码
	 window.Android.printBarCode(102, 2, 3, 6, "https://work.weixin.qq.com/u/vc3b1be9d42e188133", "gbk");

	 // 重新设定字体/对齐（有些机型在图形模式后需要再设一次）
	 window.Android.pSetFont(0, 0, 0, 0, 0);
	 window.Android.pSetPrinter(13, 1);
	  var msg = "扫码咨询免费试用云批宝";
	  window.Android.pPrintText(msg+"\n");


   window.Android.pSetFont(0, 0, 0, 0, 0);
   window.Android.pSetFont(0, 0, 1, 1, 0);
   window.Android.pSetPrinter(13, 0);
   window.Android.pPrintText("\n");
   window.Android.pCutPaper(66, 50);
 }
// 拆成数组，支持中英文逗号
// 拆成数组，支持中英文逗号
function splitParts(str) {
  if (!str) return [];
  return String(str)
    .split(/[，,]/)
    .map(function (s) { return s.trim(); })
    .filter(function (s) { return s; });
}

// 是否重量单位
function isWeightUnitStr(str) {
  if (!str) return false;
  return /斤|公斤|kg|KG/.test(str);
}

// 解析数量: "346件,3460斤" => { qty: "346件", weight: "3460斤" }
function parseQty(raw) {
  var parts = splitParts(raw);
  var res = { qty: "", weight: "" };
  if (!parts.length) return res;

  if (parts.length === 1) {
    if (isWeightUnitStr(parts[0])) {
      res.weight = parts[0];
    } else {
      res.qty = parts[0];
    }
    return res;
  }

  // 有多个时找一个当数量，一个当重量
  for (var i = 0; i < parts.length; i++) {
    var p = parts[i];
    if (!res.qty && !isWeightUnitStr(p)) {
      res.qty = p;
    } else if (!res.weight && isWeightUnitStr(p)) {
      res.weight = p;
    }
  }

  if (!res.qty) res.qty = parts[0];
  return res;
}

// 解析均价: "0.63/件,0.06/公斤" => { priceQty: "...", priceWeight: "..." }
function parsePrice(raw) {
  var parts = splitParts(raw);
  var res = { priceQty: "", priceWeight: "" };
  if (!parts.length) return res;

  if (parts.length === 1) {
    if (isWeightUnitStr(parts[0])) {
      res.priceWeight = parts[0];
    } else {
      res.priceQty = parts[0];
    }
    return res;
  }

  res.priceQty = parts[0];
  res.priceWeight = parts[1];
  return res;
}

export function sprt_print_pici_jiesuan_toal(
  selectPici,
  moneys,
  moneyTotal,
  expenses,
  jiesuan
) {
  var userinfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  // 标题
  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 1, 1, 1, 0);
  window.Android.pSetPrinter(13, 1);
  window.Android.pPrintText((userinfo.dangkou_name || "") + "批次结算单\n");
  window.Android.pPrintText("\n");

  // 基础信息
  window.Android.pSetFont(0, 0, 0, 1, 0);
  window.Android.pSetPrinter(13, 0);
  window.Android.pPrintText(
    "货主：" + (selectPici.huozhu_name || "") +
    "   批次：" + (selectPici.pici || "") + "\n"
  );

  window.Android.pSetFont(0, 0, 0, 0, 0);
  var startTime = moneyTotal.start_time ? String(moneyTotal.start_time) : "";
  var endTime   = moneyTotal.end_time   ? String(moneyTotal.end_time)   : "";
  if (startTime || endTime) {
    window.Android.pPrintText("时间段：" + startTime + "-" + endTime + "\n");
  }
  window.Android.pPrintText("\n");

  var COLS_TOTAL = 48;
  var COL3 = 16; // 三列等宽

  // 分隔线
  window.Android.pPrintText(Array(COLS_TOTAL + 1).join("-") + "\n");

  // ===== 明细：每个商品 3~4 行 =====
  (moneys || []).forEach(function (detail) {
    var name    = String(detail.goods_name || "");
    var amtText = detail.goods_price != null ? String(detail.goods_price) : "";

    var qtyInfo   = parseQty(detail.num);
    var priceInfo = parsePrice(detail.single);

    var hasQty        = !!qtyInfo.qty;
    var hasWeight     = !!qtyInfo.weight;
    var hasPriceQty   = !!priceInfo.priceQty;
    var hasPriceWeight= !!priceInfo.priceWeight;

    // 如果你有入库/报损/剩余字段，这里用真实字段，没有就给 0
    var inVal   = detail.ruku_num   != null ? detail.ruku_num   : 0;
    var lossVal = detail.loss_num   != null ? detail.loss_num   : 0;
    var leftVal = detail.left_num   != null ? detail.left_num   : 0;

    // 行1：品名：xxx
    var line1 = "品名：" + name;
    line1 = sliceToWidth(line1, COLS_TOTAL);
    line1 = padRight(line1, COLS_TOTAL);
    window.Android.pPrintText(line1 + "\n");

    // 行2/行3 动态拼
    // 工具：三列对齐
    function line3col(c1, c2, c3) {
      return (
        padRight(sliceToWidth(c1 || "", COL3), COL3) +
        padRight(sliceToWidth(c2 || "", COL3), COL3) +
        padRight(sliceToWidth(c3 || "", COL3), COL3)
      );
    }

    // 情况一：有数量也有重量 => 打两行
    if (hasQty && hasWeight) {
      // 行2：数量 + 对应均价(优先 priceQty) + 货款
      var l2_c1 = "数量:" + qtyInfo.qty;
      var l2_price = hasPriceQty ? priceInfo.priceQty
                     : (hasPriceWeight ? priceInfo.priceWeight : "");
      var l2_c2 = l2_price ? "均价:" + l2_price : "";
      var l2_c3 = "货款:" + (amtText || "");
      window.Android.pPrintText(line3col(l2_c1, l2_c2, l2_c3) + "\n");

      // 行3：重量 + 对应均价(优先 priceWeight) + 空
      var l3_c1 = "重量:" + qtyInfo.weight;
      var l3_price = hasPriceWeight ? priceInfo.priceWeight
                      : (hasPriceQty ? priceInfo.priceQty : "");
      var l3_c2 = l3_price ? "均价:" + l3_price : "";
      window.Android.pPrintText(line3col(l3_c1, l3_c2, "") + "\n");
    }
    // 情况二：只有数量
    else if (hasQty && !hasWeight) {
      var pOnly =
        hasPriceQty ? priceInfo.priceQty :
        (hasPriceWeight ? priceInfo.priceWeight : "");
      var c1 = "数量:" + qtyInfo.qty;
      var c2 = pOnly ? "均价:" + pOnly : "";
      var c3 = "货款:" + (amtText || "");
      window.Android.pPrintText(line3col(c1, c2, c3) + "\n");
    }
    // 情况三：只有重量
    else if (!hasQty && hasWeight) {
      var pwOnly =
        hasPriceWeight ? priceInfo.priceWeight :
        (hasPriceQty ? priceInfo.priceQty : "");
      var cw1 = "重量:" + qtyInfo.weight;
      var cw2 = pwOnly ? "均价:" + pwOnly : "";
      var cw3 = "货款:" + (amtText || "");
      window.Android.pPrintText(line3col(cw1, cw2, cw3) + "\n");
    }
    // 情况四：啥都没有，就只打印货款一行避免空行
    else {
      if (amtText) {
        window.Android.pPrintText(line3col("", "", "货款:" + amtText) + "\n");
      }
    }

    // 行4：入库 / 报损 / 剩余（固定三列）
    var l4_c1 = "入库:" + inVal;
    var l4_c2 = "报损:" + lossVal;
    var l4_c3 = "剩余:" + leftVal;
    window.Android.pPrintText(line3col(l4_c1, l4_c2, l4_c3) + "\n");

    // 分隔线
    window.Android.pPrintText(Array(COLS_TOTAL + 1).join("-") + "\n");
  });

  // 汇总（照原来 3 列对齐）
  var sumLine =
    padRight("总件数:" + (moneyTotal.total_num || 0), COL3) +
    padRight("总重量:" + (moneyTotal.total_weight || 0), COL3) +
    padRight("合计:" + (moneyTotal.total_goods_price || 0), COL3);
  window.Android.pPrintText(sumLine + "\n");

  // 费用（维持你之前逻辑）
  if (expenses && expenses.length > 0) {
    window.Android.pPrintText(Array(COLS_TOTAL + 1).join("-") + "\n");

    var COLS_INDEX = 8;
    var COLS_NAME2 = 16;
    var COLS_MONEY = 12;
    var COLS_NOTE  = 12;

    var hi = padRight("序号",   COLS_INDEX);
    var hn = padRight("费用项", COLS_NAME2);
    var hm = padRight("金额",   COLS_MONEY);
    var ht = padRight("备注",   COLS_NOTE);
    window.Android.pPrintText(hi + hn + hm + ht + "\n");
    window.Android.pPrintText(Array(COLS_TOTAL + 1).join("-") + "\n");

    expenses.forEach(function (e, i) {
      var ci = padRight(String(i + 1),              COLS_INDEX);
      var cn = padRight(sliceToWidth(e.name  || "", COLS_NAME2),  COLS_NAME2);
      var cm = padRight(sliceToWidth(e.money || "", COLS_MONEY),  COLS_MONEY);
      var ct = padRight(sliceToWidth(e.notes || "", COLS_NOTE),   COLS_NOTE);
      window.Android.pPrintText(ci + cn + cm + ct + "\n");
    });

    window.Android.pPrintText(
      "合计费用：" + (moneyTotal.total_zhichu || 0) + " 元\n"
    );
  }

  // 结算金额 & 备注
  window.Android.pPrintText(Array(COLS_TOTAL + 1).join("-") + "\n");
  window.Android.pPrintText("结算金额:" + (jiesuan || 0) + "元\n");

  if (selectPici.notes && String(selectPici.notes).trim() !== "") {
    window.Android.pPrintText("\n备注内容：" + String(selectPici.notes) + "\n");
  }

  // 二维码
  window.Android.pSetPrinter(13, 1);
  window.Android.printBarCode(
    102,
    2,
    3,
    6,
    "https://work.weixin.qq.com/u/vc3b1be9d42e188133",
    "gbk"
  );
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pSetPrinter(13, 1);
  window.Android.pPrintText("扫码咨询免费试用云批宝\n");
  window.Android.pPrintText("\n");
  window.Android.pCutPaper(66, 50);
}






 export function sprt_print_sale_detail(header, list, pici_info) {
   var userinfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
   // var printer_info = JSON.parse(localStorage.getItem("printer_info") || "{}");

   window.Android.pPrintText("\n");
   window.Android.pSetFont(0, 1, 1, 1, 0);
   window.Android.pSetPrinter(13, 1);
   window.Android.pPrintText((userinfo.dangkou_name || "") + "批次销售明细单\n");
   window.Android.pPrintText("\n");

   window.Android.pSetFont(0, 0, 0, 1, 0);
   window.Android.pSetPrinter(13, 0);
   window.Android.pPrintText(
     "货主：" + (pici_info.huozhu_name || "") +
     "  批次：" + (pici_info.pici || "") + "\n"
   );
   window.Android.pSetFont(0, 0, 0, 0, 0);
   window.Android.pPrintText(
     "时间段:" +
     (pici_info.start || "") +
     "-" +
     (pici_info.end || "") +
     "\n"
   );

   // ===== 列宽配置（总宽 48）=====
   var COLS_TOTAL = 48;
   var COLS_NAME  = 18; // 货品/时间/票号
   var COLS_QTY   = 10; // 销量
   var COLS_PRICE = 10; // 均价
   var COLS_AMT   = 10; // 货款（右对齐）

   function line() {
     return new Array(COLS_TOTAL + 1).join("-");
   }

   window.Android.pPrintText(line() + "\n");

   // ===== 表头：严格按列宽对齐 =====
   var hName  = padRight(sliceToWidth("货品/时间/票号", COLS_NAME),  COLS_NAME);
   var hQty   = padRight(sliceToWidth("销量",         COLS_QTY),   COLS_QTY);
   var hPrice = padRight(sliceToWidth("均价",         COLS_PRICE), COLS_PRICE);
   var hAmt   = padLeft (sliceToWidth("货款",         COLS_AMT),   COLS_AMT);

   window.Android.pPrintText(hName + hQty + hPrice + hAmt + "\n");
   window.Android.pPrintText(line() + "\n");

   window.Android.pSetFont(0, 0, 0, 1, 0);

   // ===== 明细行 =====
   // 约定：
   // list[0]：汇总行 => 使用 goods_name / sell / single / goods_price
   // index>0：明细行 => 使用 date / piao_num / sell / single / goods_price
   list.forEach(function (item, index) {
     // 拆销量 & 均价（支持 "4包,40斤" / "77/包,7.7/斤"）
     var sells  = splitParts(item.sell_str || item.sell || "");
     var prices = splitParts(item.single || "");
     var amt    = item.goods_price != null ? String(item.goods_price) : "";

     // 至少也打印一行
     var rows = Math.max(
       sells.length || 1,
       prices.length || 1
     );

     // 第一列：名称/时间/票号
     var baseName;
     if (index === 0) {
       // 汇总行展示：序号 + 品名
       baseName = (index + 1) + " " + (item.goods_name || "");
     } else {
       // 明细行展示：日期 票号
       baseName = (item.date || "") + " " + (item.piao_num || "");
     }

     for (var i = 0; i < rows; i++) {
       var nameText  = (i === 0) ? baseName : "";                       // 首行显示名，后续行留空
       var qtyText   = (i < sells.length)  ? sells[i]  : "";            // 对应销量
       var priceText = (i < prices.length) ? prices[i] : "";            // 对应均价
       var amtText   = (i === 0) ? amt : "";                            // 货款只在首行显示

       // 每列：先截断到列宽，再左右对齐填空格，保证总宽不乱
       var cName  = padRight(sliceToWidth(nameText,  COLS_NAME),  COLS_NAME);
       var cQty   = padRight(sliceToWidth(qtyText,   COLS_QTY),   COLS_QTY);
       var cPrice = padRight(sliceToWidth(priceText, COLS_PRICE), COLS_PRICE);
       var cAmt   = padLeft (sliceToWidth(amtText,   COLS_AMT),   COLS_AMT);

       window.Android.pPrintText(cName + cQty + cPrice + cAmt + "\n");
     }
   });

   // ===== 底部汇总 =====
   window.Android.pSetFont(0, 0, 0, 0, 0);
   window.Android.pPrintText(line() + "\n");

   window.Android.pSetFont(0, 0, 1, 1, 0);
   window.Android.pSetPrinter(13, 0);

   if (list && list.length) {
     // 这里沿用你原先逻辑：总销量、总货款从首行取
     var first = list[0];
     window.Android.pPrintText("总销量:" + (first.sell || "") + "\n");
     window.Android.pPrintText("合计:" + (first.goods_price || "") + "元\n");
   }


		window.Android.pSetPrinter(13, 1);

   // 打印条码/二维码
   window.Android.printBarCode(102, 2, 3, 6, "https://work.weixin.qq.com/u/vc3b1be9d42e188133", "gbk");

   // 重新设定字体/对齐（有些机型在图形模式后需要再设一次）
   window.Android.pSetFont(0, 0, 0, 0, 0);
   window.Android.pSetPrinter(13, 1);
    var msg = "扫码咨询免费试用云批宝";
    window.Android.pPrintText(msg+"\n");




   window.Android.pPrintText("\n");
   window.Android.pCutPaper(66, 50);
 }


export function sprt_printer_order(item) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "-赊欠对账单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText("买家：" + item.maijia + "\n");
	window.Android.pPrintText(
		"起止时间:" + item.start_time + "-" + item.end_time + "\n"
	);

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("---------------------------------------------\n");
	//循环开始
	window.Android.pPrintText("日期          单号       数量       金额\n");

	window.Android.pPrintText("---------------------------------------------\n");

	item.data.forEach((itemdetail, index) => {
		if (itemdetail.changdu == 1) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"          " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 2) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"         " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 3) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"          " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 4) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"       " +
					itemdetail.total_price +
					"\n"
			);
		}
		if (itemdetail.changdu == 5) {
			window.Android.pPrintText(
				itemdetail.date +
					"         " +
					itemdetail.piao_num +
					"        " +
					itemdetail.num +
					"      " +
					itemdetail.total_price +
					"\n"
			);
		}
	});

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	window.Android.pPrintText("赊欠单数:" + item.num + "\n");
	window.Android.pPrintText("采购金额:" + item.total + "元\n");
	window.Android.pPrintText("已付:" + item.pay + "元\n");
	window.Android.pPrintText("赊欠:" + item.nopay + "元\n");
	window.Android.pPrintText("\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("操作人员:" + item.user._user.name + "\n");
	window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

	window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link, "gbk");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText("扫描方二维码查看溯源，以上食用农产品均已履\n");
	window.Android.pPrintText("行进货检查验收法定程序，索证索票齐全，销售\n");
	window.Android.pPrintText("者特此声明\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}
export function sprt_printer_huankuan_order_detail(item) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "还款凭证\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText("买家：" + item.maijia + "\n");
	window.Android.pPrintText(
		"起止时间:" + item.start_time + "-" + item.end_time + "\n"
	);

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);

item.data.forEach((itemdetail, index) => {
  // 若还款为 0（含 "0"、"0.00" 等），整块不打印
  const repay = (itemdetail.huankuan_num !== undefined && itemdetail.huankuan_num !== null)
    ? parseFloat(String(itemdetail.huankuan_num).trim())
    : NaN;
  if (isNaN(repay) || repay === 0) return; // forEach 里 return 等同于“跳过当前项”

  // 以下保持你原来的打印逻辑
  window.Android.pPrintText("===============" + itemdetail.add_time + "==========\n");
  window.Android.pPrintText("品名           销量        单价       小计\n");

  itemdetail.order_detail.forEach((itemdetaildetail, indexdetail) => {
    let msg = indexdetail + 1 + "." + itemdetaildetail.goods_name_str;

    for (let i = 0; i < 11 - itemdetaildetail.goods_name_str.length; i++) msg += " ";
    msg += itemdetaildetail.buy;
    for (let i = 0; i < 14 - itemdetaildetail.buy_changdu; i++) msg += " ";
    msg += itemdetaildetail.price;
    for (let i = 0; i < 11 - itemdetaildetail.price_changdu; i++) msg += " ";

    window.Android.pPrintText(msg + itemdetaildetail.total_price + "\n");
  });

  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pPrintText("还款：" + itemdetail.huankuan_num + "元\n");
  window.Android.pSetFont(0, 0, 0, 0, 0);
});

	window.Android.pPrintText(
		"======================总计======================\n"
	);

	window.Android.pSetFont(0, 0, 0, 0, 0);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	let pay_str = "";
	pay_str = pay_str + (item.cash_num > 0 ? +item.cash_num + "(现金)" : "");
	pay_str = pay_str + (item.wepay_num > 0 ? +item.wepay_num + "(微信)" : "");
	pay_str =
		pay_str + (item.alipay_num > 0 ? +item.alipay_num + "(支付宝)" : "");
	pay_str = pay_str + (item.union_num > 0 ? +item.union_num + "(银联)" : "");
	pay_str = pay_str + (item.other_num > 0 ? +item.other_num + "(其他)" : "");

	window.Android.pPrintText("还款单数:" + item.num + "\n");
	window.Android.pPrintText("本次还款:" + pay_str + "\n");
	window.Android.pPrintText("还    欠:" + item.nopay + "\n");
	window.Android.pPrintText("\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("收银员:" + item.user._user.name + "\n");
	window.Android.pPrintText("商行地址:" + userinfo.dangkou_address + "\n");

	window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link, "gbk");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText("扫描方二维码查看溯源，以上食用农产品均已履\n");
	window.Android.pPrintText("行进货检查验收法定程序，索证索票齐全，销售\n");
	window.Android.pPrintText("者特此声明\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}

export function sprt_printer_order_detail(item) {
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 1, 1, 1, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText(userinfo.dangkou_name + "明细赊欠对账单\n");

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 0); //
	window.Android.pPrintText("买家：" + item.maijia + "\n");
	window.Android.pPrintText(
		"起止时间:" + item.start_time + "-" + item.end_time + "\n"
	);

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);

	item.data.forEach((itemdetail, index) => {
		window.Android.pPrintText(
			"===============" + itemdetail.add_time + "==========\n"
		);
		//循环开始
		window.Android.pPrintText("品名          采购量       单价       小计\n");

		itemdetail.order_detail.forEach((itemdetaildetail, indexdetail) => {
			let msg = indexdetail + 1 + "." + itemdetaildetail.goods_name_str;

			for (let i = 0; i < 10 - itemdetaildetail.goods_name_str.length; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetaildetail.buy;
			for (let i = 0; i < 14 - itemdetaildetail.buy_changdu; i++) {
				msg = msg + " ";
			}
			msg = msg + itemdetaildetail.price;
			for (let i = 0; i < 11 - itemdetaildetail.price_changdu; i++) {
				msg = msg + " ";
			}

			window.Android.pPrintText(msg + itemdetaildetail.total_price + "\n");
		});

		window.Android.pPrintText("合计：" + itemdetail.total_price + "元\n");
		window.Android.pPrintText("赊欠：" + itemdetail.sheqian + "元\n");
	});
	window.Android.pPrintText(
		"======================总计======================\n"
	);

	window.Android.pSetFont(0, 0, 0, 0, 0);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	window.Android.pPrintText("采购金额:" + item.total + "元\n");
	window.Android.pPrintText("已付:" + item.pay + "元\n");
	window.Android.pPrintText("赊欠:" + item.nopay + "元\n");
	window.Android.pPrintText("\n");

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("操作人员:" + item.user._user.name + "\n");
	window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

	window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link, "gbk");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 1); //
	window.Android.pPrintText("扫描方二维码查看溯源，以上食用农产品均已履\n");
	window.Android.pPrintText("行进货检查验收法定程序，索证索票齐全，销售\n");
	window.Android.pPrintText("者特此声明\n");

	window.Android.pCutPaper(66, 50);
	// apis.print_history();
}

export function sprt_printer_huankuan_summary(summary) {
  summary = summary || {};

  var userinfo = {};
  var printer_info = {};

  try {
    userinfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  } catch (e) {
    userinfo = {};
  }


  try {
    printer_info = JSON.parse(localStorage.getItem("printer_info") || "{}");
  } catch (e) {
    printer_info = {};
  }

  // 安全取值
  function safe(v, def) {
    return (v === undefined || v === null) ? (def === undefined ? "" : def) : v;
  }

  // 金额格式化（保留2位但不强制补0，保持你原来风格）
  function fmtMoney(m) {
    var n = Number(m || 0);
    return (Math.round(n * 100) / 100).toString();
  }

  // ✅ 计算“打印宽度”：ASCII=1，其它(中文等)=2
  function printWidth(s) {
    if (s === undefined || s === null) s = "";
    s = String(s);
    var w = 0;
    for (var i = 0; i < s.length; i++) {
      var code = s.charCodeAt(i);
      w += (code <= 0x7f) ? 1 : 2;
    }
    return w;
  }

  // ✅ 截断到指定打印宽度（可选后缀）
  function cutByWidth(s, width, suffix) {
    if (s === undefined || s === null) s = "";
    s = String(s);
    suffix = suffix || "";
    var sw = printWidth(suffix);

    if (width <= 0) return "";
    if (printWidth(s) <= width) return s;

    var out = "";
    var w = 0;
    for (var i = 0; i < s.length; i++) {
      var cw = (s.charCodeAt(i) <= 0x7f) ? 1 : 2;
      if (w + cw > width - sw) break;
      out += s.charAt(i);
      w += cw;
    }
    return out + suffix;
  }

  // ✅ 右补空格（按打印宽度）
  function padRightW(s, width) {
    if (s === undefined || s === null) s = "";
    s = String(s);
    var n = width - printWidth(s);
    if (n <= 0) return s;
    return s + new Array(n + 1).join(" ");
  }

  // ✅ 左补空格（按打印宽度）——用于数字右对齐
  function padLeftW(s, width) {
    if (s === undefined || s === null) s = "";
    s = String(s);
    var n = width - printWidth(s);
    if (n <= 0) return s;
    return new Array(n + 1).join(" ") + s;
  }

  // list / total
  var list = summary.list;
  if (!Array.isArray(list)) list = [];
  var total = summary.total ? summary.total : {};

  var start_time = safe(summary.start_time, "");
  var end_time = safe(summary.end_time, "");

  // ✅ 一行固定 48 列（包含空格）
  var LINE_W = 48;

  // ✅ 列宽总和必须=48（你可按需要微调，但总和必须一致）
  var NO_W = 10;      // 序号
  var NAME_W = 18;   // 买家
  var ORD_W = 6;     // 单数
  var MONEY_W = 14;  // 金额
  // 4 + 24 + 6 + 14 = 48 ✅

  // ✅ 强制一行刚好 48：超出截断，不足补空格
  function ensureLine48(s) {
    s = cutByWidth(s, LINE_W, "");
    s = padRightW(s, LINE_W);
    return s;
  }

  function hr() {
    return new Array(LINE_W + 1).join("-");
  }

  // ===== 打印开始 =====
  if (!window.Android || !window.Android.pPrintText) {
    console.warn("Android 打印桥接不存在：window.Android");
    return;
  }

  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 1, 1, 1, 0);
  window.Android.pSetPrinter(13, 1);
  window.Android.pPrintText((safe(userinfo.dangkou_name, "") || "") + summary.print_name+"\n");

  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pSetPrinter(13, 0);

    window.Android.pPrintText("当班员:" + userinfo.name +"\n");

  // 起止时间
  if (start_time || end_time) {
    window.Android.pPrintText("起止时间:" + start_time + "-" + end_time + "\n");
  }

  // ✅ 表头（强制占满一行48）
  var header =
    padRightW("序号", NO_W) +
    padRightW("买家", NAME_W) +
    padLeftW("单数", ORD_W) +
    padLeftW("金额", MONEY_W);

  window.Android.pPrintText(ensureLine48(header) + "\n");
  window.Android.pPrintText(hr() + "\n");

  // ✅ 数据行（每行都 ensureLine48，保证占满 + 对齐）
  for (var i = 0; i < list.length; i++) {
    var row = list[i] || {};
    var no = safe(row.no, "");
    var name = safe(row.maijia_name, "-");
    var orders = safe(row.order_count, 0);
    var money = fmtMoney(row.money);

    // 买家名过长截断，避免顶歪后面列
    name = cutByWidth(name, NAME_W, "..");

    var line =
      padRightW(no, NO_W) +
      padRightW(name, NAME_W) +
      padLeftW(String(orders), ORD_W) +
      padLeftW(String(money), MONEY_W);

    window.Android.pPrintText(ensureLine48(line) + "\n");
  }

  window.Android.pPrintText(hr() + "\n");

  // 总计
  var totalOrders = safe(total.order_count, 0);
  var totalMoney = fmtMoney(total.money);

  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pSetPrinter(13, 0);
  window.Android.pPrintText("总单数:" + totalOrders + "\n");
  window.Android.pPrintText("总金额:" + totalMoney + "元\n");

  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 0, 0, 0, 0);

  // 操作人员
  if (userinfo && userinfo.nickname) {
    window.Android.pPrintText("操作人员:" + userinfo.nickname + "\n");
  }

  // 二维码 + 声明
  // 打条码/二维码（102常用于QR）
  window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link?printer_info.shoukuan_link:"https://work.weixin.qq.com/u/vc3b1be9d42e188133", "gbk");

  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pSetPrinter(13, 1);
  //底部文案：有自定义用自定义，否则回退
  var linkTextRaw = (printer_info.shoukuan_link_text != null)
    ? String(printer_info.shoukuan_link_text).trim()
    : "";
  var shopName = (userinfo && userinfo.dangkou_name) ? userinfo.dangkou_name : "";
  var msg = linkTextRaw ? printer_info.shoukuan_link_text : ("扫码咨询免费试用云批宝");

  // 末尾带换行，避免下一段贴行
  window.Android.pPrintText(msg + "\n");


  window.Android.pCutPaper(66, 50);
}


export function sprt_printer2(item) {

	const COLS_STATUS = 24;
	const COLS_PIAONUM = 24;
	const COLS_LEFT  = 32;
	const COLS_RIGHT = 16;
	const isBlank = v =>
	  v === undefined || v === null || String(v).trim() === "" || Number(v) === 0;
	let leftText = "";
	let rightText = "";
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	let pay_status = "";

	if (item.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (item.yingshou == item.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (item.status == 1) {
		pay_status = "已付款";
	}

	const num = 1;
const TOTAL_TOP = 24;
function lineEnds(leftText, rightText, total = TOTAL_TOP) {
  const R = sliceToWidth(rightText || "", total);
  const maxLeft = Math.max(0, total - textWidth(R));
  const L = sliceToWidth(leftText || "", maxLeft);
  const gap = total - textWidth(L) - textWidth(R);
  return L + " ".repeat(gap) + R;
}

// ===== 票号 & 状态（这一行放大，按 24 列排）=====
if (printer_info.field.header[0].checked && printer_info.field.header[1].checked) {
  window.Android.pSetFont(0, 1, 1, 0, 0);  // 放大
  window.Android.pSetPrinter(13, 0);
  window.Android.pPrintText(lineEnds(pay_status, item.piao_num) + "\n");
} else if (!printer_info.field.header[0].checked && printer_info.field.header[1].checked) {
  window.Android.pSetFont(0, 1, 1, 0, 0);
  window.Android.pSetPrinter(13, 0);
  window.Android.pPrintText(lineEnds("", item.piao_num) + "\n");
} else if (printer_info.field.header[0].checked && !printer_info.field.header[1].checked) {
  window.Android.pSetFont(0, 1, 1, 0, 0);
  window.Android.pSetPrinter(13, 0);
  window.Android.pPrintText(lineEnds(pay_status, "") + "\n");
}



	if (printer_info.field.header[2].checked) {
		window.Android.pSetFont(0, 0, 0, 0, 0);
		window.Android.pSetPrinter(13, 2); //
		window.Android.pPrintText(item.user.name + "\n");
	}

	if (printer_info.field.header[3].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 0, 0, 1, 0);
		window.Android.pSetPrinter(13, 1); //
		window.Android.pPrintText(userinfo.area + "\n");
	}
	if (printer_info.field.header[4].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 1, 0);
		window.Android.pSetPrinter(13, 1); //
		window.Android.pPrintText(userinfo.dangkou_name + "-销售凭证\n");
	}
	if (printer_info.field.header[5].checked) {
		window.Android.pPrintText("\n");
		window.Android.pSetFont(0, 1, 1, 0, 0);
		window.Android.pSetPrinter(13, 0); //
		window.Android.pPrintText("买家:" + item.maijia + "\n");
	}

	window.Android.pPrintText("\n");
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText("---------------------订单明细----------------\n");
	//循环开始

	item.order_detail.forEach((item, index) => {
		let header_text = "";
		let header_text1 = "";
		let fujiafei_msg = "";
		let leftText = "";

		 // 左侧：品名 + 批次（按宽截断，避免把右侧挤换行）
		 if (isFieldChecked("goods", "goods_name")) {
		   leftText += (index + 1) + "." + (item.goods_name || "");
		 }
		 if (isFieldChecked("goods", "huozhupici") && item.order_detail_pici) {
		   leftText += "(" + item.order_detail_pici.huozhu_name + "-" + item.order_detail_pici.pici + ")";
		 }

		 // 右侧：小计
		 if (isFieldChecked("goods", "goods_total")) {
		   rightText = "小计:" + (item.total_price ?item.total_price: "") + "元";
		 }

		 // 两列对齐打印（左对齐 + 右对齐），严格 48 列
		 const leftCol  = padRight(sliceToWidth(leftText,  COLS_LEFT),  COLS_LEFT);
		 const rightCol = padLeft (sliceToWidth(rightText, COLS_RIGHT), COLS_RIGHT);

		 window.Android.pSetFont(0, 0, 1, 1, 0);
		 window.Android.pPrintText(leftCol + rightCol + "\n");

		window.Android.pSetFont(0, 0, 0, 0, 0);
		// window.Android.pPrintText("\n");

		let enabledGoodsFields = [];

	if (printer_info.field.goods[2].checked) {
	    const raw = (item.show_num_weight || '').trim();

	    let numPart = '';
	    let weightPart = '';

	    if (raw) {
	        if (raw.includes('/')) {
	            // 正常情況：xx件/xx公斤
	            const parts = raw.split('/', 2).map(s => s.trim());
	            numPart = parts[0] || '';
	            weightPart = parts[1] || '';
	        } else {
	            // 只有一段：含「公」或「斤」視為重量，否則視為數量
	            if (raw.includes('公') || raw.includes('斤')) {
	                weightPart = raw;
	            } else {
	                numPart = raw;
	            }
	        }
	    }

	    const textParts = [];
	    if (numPart) {
	        textParts.push('数量:' + numPart);
	    }
	    if (weightPart) {
	        textParts.push('重量:' + weightPart);
	    }

	    // 分別 push，每個佔一行，方便下面用換行組合
	    textParts.forEach(part => {
	        enabledGoodsFields.push(part);
	    });
	}


		if (printer_info.field.goods[3].checked) {
			if (item.huozhu_num > 0) {
				enabledGoodsFields.push("单价:(包)" + item.price+"元/"+item.unit);
			} else {
				enabledGoodsFields.push("单价:" + item.price+"元/"+item.unit);
			}
		}

		if (printer_info.field.goods[4].checked) {
			// enabledGoodsFields.push(`货款:${goods_price}`);
			enabledGoodsFields.push("货款:" + item.goods_price+ "元 ");
		}

		item.order_detail_fujiafei.forEach(itemj => {
			printer_info.field.goods.forEach(item => {
				if (
					item.extend == "fujiafei" &&
					item.checked &&
					item.field_name == itemj.name
				) {
					fujiafei_msg =
						fujiafei_msg + item.field_name + ":" + itemj.total + "元 ";
				}
			});
		});
		item.order_detail_fujiafei.forEach(itemj => {
			printer_info.field.goods.forEach(item => {
				if (
					item.extend == "fujiafei" &&
					item.checked &&
					item.field_name == itemj.name
				) {
					enabledGoodsFields.push(`${item.field_name}:` + itemj.total + `元`);
				}
			});
		});

		const rowCount = Math.ceil(enabledGoodsFields.length / 3);

		for (let i = 0; i < rowCount; i++) {
			let line = "";

			// 获取当前行的三个位置的字段
			const leftIndex = i * 3;
			const centerIndex = i * 3 + 1;
			const rightIndex = i * 3 + 2;

			if (leftIndex < enabledGoodsFields.length) {
				line += padEnd(enabledGoodsFields[leftIndex], 10);
			} else {
				line += padEnd("", 10);
			}

			if (centerIndex < enabledGoodsFields.length) {
				line += padEnd(enabledGoodsFields[centerIndex], 12);
			} else {
				line += padEnd("", 12);
			}

			if (rightIndex < enabledGoodsFields.length) {
				line += enabledGoodsFields[rightIndex];
			}

			window.Android.pPrintText(line + "\n");
		}
	});

	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pPrintText(
		"------------------------------------------------\n"
	);

	window.Android.pSetFont(0, 0, 1, 1, 0);
	window.Android.pSetPrinter(13, 0); //

	if (printer_info.field.settle[1].checked) {
		let youhui = "";
		if (item.youhui > 0) {
			youhui = "优惠:" + item.youhui + "元";
		}
		if (item.duoshou > 0) {
			youhui = "多收:" + item.duoshou + "元";
		}
		if (item.huankuan) {
			let pay_str_now = "";
			pay_str_now =
				pay_str_now +
				(item.huankuan.cash_num > 0 ? " 现金:" + item.huankuan.cash_num : "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.wepay_num > 0 ? " 微信:" + item.huankuan.wepay_num : "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.alipay_num > 0
					? " 支付宝:" + item.huankuan.alipay_num
					: "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.union_num > 0 ? " 银联:" + item.huankuan.union_num : "");
			pay_str_now =
				pay_str_now +
				(item.huankuan.other_num > 0 ? " 其他:" + item.huankuan.other_num : "");
			window.Android.pPrintText(
				"总计:" + (item.yingshou + item.shishou) + "元\n"
			);
			window.Android.pPrintText("本次还款:" + item.huankuan.money + "\n");
			if (item.huan > item.huankuan.money) {
				window.Android.pPrintText("累计还款:" + item.huan + "\n");
			}
			window.Android.pPrintText("下欠:" + item.yingshou + "元" + "\n");
		} else {
			window.Android.pPrintText("总计:" + item.total_price + "元\n");
			if (youhui) {
				window.Android.pPrintText(youhui + "\n");
			}

			if (item.huan) {
				window.Android.pPrintText("累计还款:" + item.huan + "元\n");
			}

			if (pay_status === "赊欠") {
				window.Android.pPrintText("下欠:" + item.yingshou + "元\n");
			} else {
				window.Android.pPrintText("实收:" + item.shishou + "元\n");
			}
		}
	}

	window.Android.pSetFont(0, 0, 0, 0, 0);
	if (printer_info.field.settle[2].checked && !isBlank(item.notes)) {
	  window.Android.pPrintText("备注:" + String(item.notes).trim() + "\n");
	}
	if (printer_info.field.settle[4].checked) {
		window.Android.pPrintText("开单时间:" + item.add_time + "\n");
	}
	if (printer_info.field.settle[3].checked && item.sheqian) {
		window.Android.pPrintText("截止到:" + getGurrentTime() + "\n");
	}
	if (printer_info.field.settle[3].checked && item.sheqian) {
		window.Android.pSetFont(0, 0, 1, 1, 0);
		window.Android.pPrintText("赊欠总额:" + item.sheqian + "元\n");
	}
	window.Android.pSetFont(0, 0, 0, 0, 0);
	if (printer_info.field.settle[5].checked) {
		window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");
	}

	const pays = [];
	if (!isBlank(item.cash_num))   pays.push(" 现金:"   + item.cash_num);
	if (!isBlank(item.wepay_num))  pays.push(" 微信:"   + item.wepay_num);
	if (!isBlank(item.alipay_num)) pays.push(" 支付宝:" + item.alipay_num);
	if (!isBlank(item.union_num))  pays.push(" 银联:"   + item.union_num);
	if (!isBlank(item.other_num))  pays.push(" 其他:"   + item.other_num);

	const pay_str = pays.join("");
	if (printer_info.field.pay[0].checked && !isBlank(pay_str)) {
	  window.Android.pPrintText("支付方式:" + pay_str + "\n");
	}
	if (printer_info.field.other[0].checked) {
		window.Android.pPrintText("档口电话:" + userinfo.dangkou_phone + "\n");
	}
	if (printer_info.field.other[1].checked) {
		window.Android.pPrintText("档口地址:" + userinfo.dangkou_address + "\n");
	}
if (
  printer_info &&
  printer_info.field &&
  printer_info.field.other &&
  printer_info.field.other[2] &&
  printer_info.field.other[2].checked
) {


    // 先设对齐（有些机型条码会“带走”对齐状态）
    window.Android.pSetPrinter(13, 1);

    // 打条码/二维码（102常用于QR）
    window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link?printer_info.shoukuan_link:"https://work.weixin.qq.com/u/vc3b1be9d42e188133", "gbk");

    // 关键：喂纸/换行，让打印头离开二维码块
    window.Android.pPrintText("\n");
    window.Android.pPrintText("\n"); // 多一行更稳

    // 再次设字体与对齐，确保回到文本模式
    window.Android.pSetFont(0, 0, 0, 0, 0);
    window.Android.pSetPrinter(13, 1);

    // 底部文案：有自定义用自定义，否则回退
    var linkTextRaw = (printer_info.shoukuan_link_text != null)
      ? String(printer_info.shoukuan_link_text).trim()
      : "";
    var shopName = (userinfo && userinfo.dangkou_name) ? userinfo.dangkou_name : "";
    var msg = linkTextRaw ? printer_info.shoukuan_link_text : ("扫码咨询免费试用云批宝");

    // 末尾带换行，避免下一段贴行
    window.Android.pPrintText(msg + "\n");

}
	for (let i = 0; i < num; i++) {
		window.Android.pPrintText("\n");
	}
	window.Android.pCutPaper(66, 50);
	apis.print_history();
}

export function sprt_printer_template() {
  const userinfo = JSON.parse(localStorage.getItem("userInfo")) || {};
  const printer_info = JSON.parse(localStorage.getItem("printer_info")) || { field: { header: [], goods: [], settle: [], pay: [], other: [] } };

  // ========= 工具 & 列宽（与正式打印 sprt_printer 保持一致） =========
  const COLS_TOTAL  = 48;
  const COLS_NAME   = 20;
  const COLS_QTY    = 10;
  const COLS_PRICE  = 9;
  const COLS_AMT    = 9;
  const TOTAL_TOP   = 24;

  // 若全局已有这些工具函数，则可删掉以下防重复定义
  if (typeof window.isBlank !== "function") {
    window.isBlank = v => v === undefined || v === null || String(v).trim() === "";
  }
  if (typeof window.textWidth !== "function") {
    // 简易宽度：中文=2，其他=1；与你线上一致可换成同名实现
    window.textWidth = (s="") => {
      s = String(s);
      let w = 0;
      for (let ch of s) w += /[^\x00-\xff]/.test(ch) ? 2 : 1;
      return w;
    };
  }
  if (typeof window.sliceToWidth !== "function") {
    window.sliceToWidth = (s="", limit=COLS_TOTAL) => {
      s = String(s);
      let out = "", w = 0;
      for (let ch of s) {
        const add = /[^\x00-\xff]/.test(ch) ? 2 : 1;
        if (w + add > limit) break;
        out += ch; w += add;
      }
      return out;
    };
  }
  if (typeof window.padLeft !== "function") {
    window.padLeft = (s="", width=COLS_TOTAL) => {
      const w = textWidth(s);
      return w >= width ? sliceToWidth(s, width) : " ".repeat(width - w) + s;
    };
  }
  if (typeof window.padRight !== "function") {
    window.padRight = (s="", width=COLS_TOTAL) => {
      const w = textWidth(s);
      return w >= width ? sliceToWidth(s, width) : s + " ".repeat(width - w);
    };
  }
  if (typeof window.countHanzi !== "function") {
    window.countHanzi = (s="") => (String(s).match(/[^\x00-\xff]/g) || []).length;
  }
  if (typeof window.cutHanzi !== "function") {
    window.cutHanzi = (s="", maxH=7) => {
      s = String(s);
      let cnt = 0, out = "";
      for (let ch of s) {
        if (/[^\x00-\xff]/.test(ch)) cnt++;
        out += ch;
        if (cnt >= maxH) break;
      }
      return out + (s !== out ? "…" : "");
    };
  }
  if (typeof window.isFieldChecked !== "function") {
    // 仅模板演示：你正式项目里已有 isFieldChecked(组, 字段名)
    window.isFieldChecked = (group, field) => {
      // 兼容模板里用到的 header[索引]、goods[索引] 等
      // 这里只做最粗的 fallback：全按 checked=true 处理
      return true;
    };
  }

  // ========= 顶部行：状态 / 操作员 / 票号 =========
  // 模板中的开关语义（保持你的下标逻辑）：
  // header[0] => 显示状态   header[1] => 显示编号   header[2] => 显示操作员
  const showStatus = (printer_info.field.header[0].checked) === true;
  const showPiao   = (printer_info.field.header[1].checked) === true;
  const showOp     = (printer_info.field.header[2].checked) === true;

  const statusText = showStatus ? "未付款" : "";
  // 右侧组合（操作员 + 票号），再按“左右贴边，中间补空格”输出一行
  const rightChunk = (showPiao ? "112" : "");


  window.Android.pSetFont(0, 1, 1, 0, 0);
  window.Android.pSetPrinter(13, 0);




  const R   = sliceToWidth(rightChunk, TOTAL_TOP);
  const maxL= Math.max(0, TOTAL_TOP - textWidth(R));
  const L   = sliceToWidth(statusText, maxL);
  const gap = Math.max(0, TOTAL_TOP - textWidth(L) - textWidth(R));
  if (textWidth(L) + textWidth(R) > 0) {
    window.Android.pPrintText(L + " ".repeat(gap) + R + "\n");
  }
	window.Android.pSetFont(0, 0, 0, 0, 0);
	window.Android.pSetPrinter(13, 2);
	window.Android.pPrintText("操作员A");

  // ========= 区域 / 标题 / 买家 =========
  // header[3] => 区域  header[4] => 凭证标题  header[5] => 买家
  if (printer_info.field.header[3].checked) {
    window.Android.pPrintText("\n");
    window.Android.pSetFont(0, 0, 0, 1, 0);
    window.Android.pSetPrinter(13, 1);
    window.Android.pPrintText((userinfo.area || "") + "\n");
  }
  if (printer_info.field.header[4].checked) {
    window.Android.pPrintText("\n");
    window.Android.pSetFont(0, 1, 1, 1, 0);
    window.Android.pSetPrinter(13, 1);
    window.Android.pPrintText((userinfo.dangkou_name || "") + "-销售凭证\n");
  }
  if (printer_info.field.header[5].checked) {
    window.Android.pPrintText("\n");
    window.Android.pSetFont(0, 1, 1, 0, 0);
    window.Android.pSetPrinter(13, 0);
    window.Android.pPrintText("买家:" + "临时打单" + "\n");
  }

  // ========= 表头（等宽列） =========
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------------------------------------\n");
  window.Android.pSetFont(0, 0, 1, 0, 0);
  {
    const hName  = padRight(sliceToWidth("品名", COLS_NAME),  COLS_NAME);
    const hQty   = padLeft (sliceToWidth("数量", COLS_QTY),   COLS_QTY);
    const hPrice = padLeft (sliceToWidth("单价", COLS_PRICE), COLS_PRICE);
    const hAmt   = padLeft (sliceToWidth("货款", COLS_AMT),   COLS_AMT);
    window.Android.pPrintText(hName + hQty + hPrice + hAmt + "\n");
  }
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------------------------------------\n");

  // ========= 一行“演示商品”内容（按开关显示/占位对齐） =========
  // goods[0] => 品名  goods[2] => 数量  goods[1] => 单价  goods[3] => 货款
  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pSetPrinter(13, 0);

  const demoName   = "海南大香蕉";
  const nameShow   = countHanzi(demoName) > 7 ? cutHanzi(demoName, 7) : demoName;
  const nameCol    = padRight(sliceToWidth(nameShow, COLS_NAME), COLS_NAME);

  const qtyShow    = sliceToWidth("1公斤", COLS_QTY);
  const qtyCol     = padLeft(qtyShow, COLS_QTY);

  const priceShow  = sliceToWidth("8", COLS_PRICE);
  const priceCol   = padLeft(priceShow, COLS_PRICE);

  const amtShow    = sliceToWidth("8.80", COLS_AMT);
  const amtCol     = padLeft(amtShow, COLS_AMT);

  const goods0 = (printer_info.field.goods[0].checked) ? nameCol  : padRight("--", COLS_NAME);
  const goods2 = (printer_info.field.goods[2].checked) ? qtyCol   : padLeft("--", COLS_QTY);
  const goods1 = (printer_info.field.goods[1].checked) ? priceCol : padLeft("--", COLS_PRICE);
  const goods3 = (printer_info.field.goods[3].checked) ? amtCol   : padLeft("--", COLS_AMT);

  const goodsLine = goods0 + goods2 + goods1 + goods3;
  window.Android.pPrintText(goodsLine + "\n");

  // 批次/买家附加行（与原模板一致）
  window.Android.pSetFont(0, 0, 0, 1, 0);
  window.Android.pSetPrinter(13, 0);
  if (printer_info.field.header[5].checked) {
    window.Android.pPrintText("张三-9999\n");
  }

  // ========= 附加费+小计（对齐不强制列宽，保持整行输出，右对齐“小计”） =========
  let fujiafei_msg = "";
  (printer_info.field.goods || []).forEach(it => {
    if (it.extend === "fujiafei" && it.checked) fujiafei_msg += it.field_name + ":6元 ";
  });
  if (fujiafei_msg) {
    window.Android.pPrintText("附加费:(" + fujiafei_msg + ")\n");
    window.Android.pSetFont(0, 0, 1, 1, 0);
    // 右对齐小计
    const sx = sliceToWidth("小计:88元", COLS_TOTAL);
    window.Android.pSetPrinter(13, 2);
    window.Android.pPrintText(sx + "\n");
    window.Android.pSetPrinter(13, 0);
  }

  // 为了保持你原模板的“货品2/货品3”演示，这里再输出两行，同样用等宽列
  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pPrintText(goodsLine + "\n");
  window.Android.pSetFont(0, 0, 0, 1, 0);
  window.Android.pSetPrinter(13, 0);
  if (printer_info.field.header[5].checked) window.Android.pPrintText("张三-9999\n");
  if (fujiafei_msg) {
    window.Android.pPrintText("附加费:(" + fujiafei_msg + ")\n");
    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pSetPrinter(13, 2);
    window.Android.pPrintText("小计:88元\n");
    window.Android.pSetPrinter(13, 0);
  }

  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pPrintText(goodsLine + "\n");
  window.Android.pSetFont(0, 0, 0, 1, 0);
  window.Android.pSetPrinter(13, 0);
  if (printer_info.field.goods[1].checked) window.Android.pPrintText("张三-9999\n");
  if (fujiafei_msg) {
    window.Android.pPrintText("附加费:(" + fujiafei_msg + ")\n");
    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pSetPrinter(13, 2);
    window.Android.pPrintText("小计:88元\n");
    window.Android.pSetPrinter(13, 0);
  }

  // ========= 合计/结算区 =========
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------------------------------------\n");

  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pSetPrinter(13, 0);
  if (printer_info.field.settle[0].checked) window.Android.pPrintText("总件数:20件\n");
  if (printer_info.field.settle[1].checked) window.Android.pPrintText("总计:100元\n");

  // “下欠/实收”演示（保持粗体/左对齐）
  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pPrintText("下欠:20元\n");
  const payStatus = "赊欠";
  if (payStatus === "赊欠") window.Android.pPrintText("实收:80元\n");

  window.Android.pSetFont(0, 0, 0, 0, 0);
  if (printer_info.field.settle[2].checked) window.Android.pPrintText("备注:描述文字\n");
  if (printer_info.field.settle[3].checked) window.Android.pPrintText("截止到" + getGurrentTime() + "\n");
  if (printer_info.field.settle[3].checked) {
    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pPrintText("赊欠总额:100元\n");
  }
  window.Android.pSetFont(0, 0, 0, 0, 0);
  if (printer_info.field.settle[4].checked) window.Android.pPrintText("开单时间:" + getGurrentTime() + "\n");
  if (printer_info.field.settle[5].checked) window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

  if (printer_info.field.pay[0].checked) {
    window.Android.pPrintText("支付方式:现金100元,微信100元,支付宝100元\n");
  }
  if (printer_info.field.other[0].checked) window.Android.pPrintText("档口电话:" + (userinfo.dangkou_phone || "") + "\n");
  if (printer_info.field.other[1].checked) window.Android.pPrintText("档口地址:" + (userinfo.dangkou_address || "") + "\n");

if (
  printer_info &&
  printer_info.field &&
  printer_info.field.other &&
  printer_info.field.other[2] &&
  printer_info.field.other[2].checked
) {
  // 打条码
  window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link?printer_info.shoukuan_link:"https://work.weixin.qq.com/u/vc3b1be9d42e188133", "gbk");

  // 字体&对齐
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pSetPrinter(13, 1);

  // 文案优先级：shoukuan_link_text -> "扫描二维码向{店名}付款"
  var linkTextRaw = (printer_info.shoukuan_link_text != null)
    ? String(printer_info.shoukuan_link_text).trim()
    : "";

  var shopName = (userinfo && userinfo.dangkou_name) ? userinfo.dangkou_name : "";
  var msg = linkTextRaw ? printer_info.shoukuan_link_text : ("扫码咨询免费试用云批宝");

  window.Android.pPrintText(msg);
}

  window.Android.pPrintText("\n");
  window.Android.pCutPaper(66, 50);
  apis.print_history();
}

export function sprt_printer_template2() {
  var userinfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  var printer_info = JSON.parse(localStorage.getItem("printer_info") || "{}");


  // ==== 兜底结构，防止取值报错 ====
  if (!printer_info.field) {
    printer_info.field = { header: [], goods: [], settle: [], pay: [], other: [] };
  }
  ["header","goods","settle","pay","other"].forEach(function (k) {
    if (!printer_info.field[k]) printer_info.field[k] = [];
  });

  // ==== 宽度 & 工具 ====
  var COLS_TOTAL = 48;
  var COLS_NAME  = 20;  // 商品标题左列
  var RIGHT_W    = 28;  // 商品标题右列(放小计)
  var GRID_W_L   = 16, GRID_W_M = 16, GRID_W_R = 16; // 详情三栏=48
  var TOTAL_TOP  = 24;  // 顶部左右贴边宽

  function textWidth(s) {
    s = String(s || "");
    var w = 0, i, ch;
    for (i = 0; i < s.length; i++) {
      ch = s.charAt(i);
      w += /[^\x00-\xff]/.test(ch) ? 2 : 1;
    }
    return w;
  }
  function sliceToWidth(s, limit) {
    s = String(s || "");
    var out = "", w = 0, i, ch, add;
    for (i = 0; i < s.length; i++) {
      ch = s.charAt(i);
      add = /[^\x00-\xff]/.test(ch) ? 2 : 1;
      if (w + add > limit) break;
      out += ch; w += add;
    }
    return out;
  }
  function padLeft(s, width) {
    s = String(s || "");
    var w = textWidth(s);
    if (w >= width) return sliceToWidth(s, width);
    return Array(width - w + 1).join(" ") + s;
  }
  function padRight(s, width) {
    s = String(s || "");
    var w = textWidth(s);
    if (w >= width) return sliceToWidth(s, width);
    return s + Array(width - w + 1).join(" ");
  }
  function isChecked(group, idx) {
    var g = printer_info && printer_info.field && printer_info.field[group];
    return !!(g && g[idx] && g[idx].checked);
  }

  // ==== 顶部：状态 / 操作员 / 编号（左右贴边对齐） ====
  if (
    isChecked("header", 0) ||
    isChecked("header", 1) ||
    isChecked("header", 2)
  ) {
    window.Android.pSetFont(0, 1, 1, 0, 0);
    window.Android.pSetPrinter(13, 0);

    var leftTxt  = isChecked("header", 0) ? "未付款" : "";
    var rightTxt = "";
    if (isChecked("header", 2)) rightTxt += "";
    if (isChecked("header", 2) && isChecked("header", 1)) rightTxt += " ";
    if (isChecked("header", 1)) rightTxt += "112";

    // 右侧先截到 TOTAL_TOP，左侧再截到剩余宽度，中间补空格
    var R = sliceToWidth(rightTxt, TOTAL_TOP);
    var maxL = Math.max(0, TOTAL_TOP - textWidth(R));
    var L = sliceToWidth(leftTxt, maxL);
    var gap = Math.max(0, TOTAL_TOP - textWidth(L) - textWidth(R));

    if (textWidth(L) + textWidth(R) > 0) {
      window.Android.pPrintText(L + Array(gap + 1).join(" ") + R + "\n");
    }
		window.Android.pSetFont(0, 0, 0, 0, 0);
		window.Android.pSetPrinter(13, 2);
		window.Android.pPrintText("操作员A");
  }

  // ==== 区域 / 标题 / 买家 ====
  if (isChecked("header", 3)) {
    window.Android.pPrintText("\n");
    window.Android.pSetFont(0, 0, 0, 1, 0);
    window.Android.pSetPrinter(13, 1);
    window.Android.pPrintText((userinfo.area || "") + "\n");
  }
  if (isChecked("header", 4)) {
    window.Android.pPrintText("\n");
    window.Android.pSetFont(0, 1, 1, 1, 0);
    window.Android.pSetPrinter(13, 1);
    window.Android.pPrintText((userinfo.dangkou_name || "") + "-销售凭证\n");
  }
  if (isChecked("header", 5)) {
    window.Android.pPrintText("\n");
    window.Android.pSetFont(0, 1, 1, 0, 0);
    window.Android.pSetPrinter(13, 0);
    window.Android.pPrintText("买家:临时打单\n");
  }

  // ==== 分割线 ====
  window.Android.pPrintText("\n");
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------订单明细----------------\n");

  // ==== 打印3个货品明细（演示） ====
  for (var productIndex = 0; productIndex < 3; productIndex++) {

    // 标题行：左20列（品名+可选买家后缀），右28列放小计、右对齐
    var titleLeft = "";
    if (isChecked("goods", 0)) { // 品名开关
      titleLeft = (productIndex + 1) + ".海南大香蕉";
      if (isChecked("goods", 7)) { // 可选买家后缀
        titleLeft += "(张三-999)";
      }
    }
    var titleLeftCol = padRight(sliceToWidth(titleLeft, COLS_NAME), COLS_NAME);

    var titleRight = isChecked("goods", 6) ? "小计:88元" : "";
    // 右 28 列右对齐
    var titleRightCol = padLeft(sliceToWidth(titleRight, RIGHT_W), RIGHT_W);

    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pPrintText(titleLeftCol + titleRightCol + "\n");

    // 空行
    window.Android.pSetFont(0, 0, 0, 0, 0);
    window.Android.pPrintText("\n");

    // 详情字段收集
    var enabledGoodsFields = [];
    if (isChecked("goods", 2)) {
      enabledGoodsFields.push("数量:1公斤");
      enabledGoodsFields.push("重量:1kg");
    }
    if (isChecked("goods", 1)) {
      enabledGoodsFields.push("单价:8");
    }
    if (isChecked("goods", 3)) {
      enabledGoodsFields.push("货款:8.8");
    }
    // 附加费
    var goodsArr = printer_info.field.goods || [];
    for (var gi = 0; gi < goodsArr.length; gi++) {
      var it = goodsArr[gi];
      if (it && it.extend == "fujiafei" && it.checked) {
        enabledGoodsFields.push(String(it.field_name || "附加费") + ":6元");
      }
    }

    // 三栏网格，每行最多 3 项（16/16/16）
    var rowCount = Math.ceil(enabledGoodsFields.length / 3);
    for (var i = 0; i < rowCount; i++) {
      var leftIdx   = i * 3;
      var centerIdx = i * 3 + 1;
      var rightIdx  = i * 3 + 2;

      var colL = leftIdx   < enabledGoodsFields.length ? enabledGoodsFields[leftIdx]   : "";
      var colM = centerIdx < enabledGoodsFields.length ? enabledGoodsFields[centerIdx] : "";
      var colR = rightIdx  < enabledGoodsFields.length ? enabledGoodsFields[rightIdx]  : "";

      colL = padRight(sliceToWidth(colL, GRID_W_L), GRID_W_L);
      colM = padRight(sliceToWidth(colM, GRID_W_M), GRID_W_M);
      colR = padRight(sliceToWidth(colR, GRID_W_R), GRID_W_R);

      window.Android.pPrintText(colL + colM + colR + "\n");
    }

    // 两个分隔区之间的横线
    if (productIndex < 2) {
      window.Android.pSetFont(0, 0, 0, 0, 0);
      window.Android.pPrintText("------------------------------------------------\n");
    }
  }

  // ==== 总计分隔线 ====
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pPrintText("------------------------------------------------\n");

  // ==== 总计区 ====
  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pSetPrinter(13, 0);
  if (isChecked("settle", 0)) window.Android.pPrintText("总件数:20件\n");
  if (isChecked("settle", 1)) window.Android.pPrintText("总计:100元\n");

  // 下欠/实收演示
  window.Android.pSetFont(0, 0, 1, 1, 0);
  window.Android.pPrintText("下欠:20元\n");
  var payStatus = "赊欠";
  if (payStatus === "赊欠") window.Android.pPrintText("实收:80元\n");

  window.Android.pSetFont(0, 0, 0, 0, 0);
  if (isChecked("settle", 2)) window.Android.pPrintText("备注:描述文字\n");

  if (isChecked("settle", 3)) {
    window.Android.pPrintText("截止到:" + getGurrentTime() + "\n");
    window.Android.pSetFont(0, 0, 1, 1, 0);
    window.Android.pPrintText("累计赊欠:888元\n");
    window.Android.pSetFont(0, 0, 0, 0, 0);
  }

  if (isChecked("settle", 4)) window.Android.pPrintText("开单时间:" + getGurrentTime() + "\n");
  if (isChecked("settle", 5)) window.Android.pPrintText("打印时间:" + getGurrentTime() + "\n");

  if (isChecked("pay", 0)) {
    window.Android.pPrintText("支付方式:现金100元,微信100元,支付宝100元\n");
  }
  if (isChecked("other", 0)) window.Android.pPrintText("档口电话:" + (userinfo.dangkou_phone || "") + "\n");
  if (isChecked("other", 1)) window.Android.pPrintText("档口地址:" + (userinfo.dangkou_address || "") + "\n");

if (isChecked("other", 2)) {
  // 条码
  window.Android.printBarCode(102, 2, 3, 6, printer_info.shoukuan_link?printer_info.shoukuan_link:"https://work.weixin.qq.com/u/vc3b1be9d42e188133", "gbk");

  // 对齐/字体
  window.Android.pSetFont(0, 0, 0, 0, 0);
  window.Android.pSetPrinter(13, 1); // 13=左/中/右中的一个，保持你的现有设置

  // 文案：优先 shoukuan_link_text，否则回退到“扫描二维码向xxx付款”

  const msg =
    (printer_info.shoukuan_link_text.toString().trim())
      ? printer_info.shoukuan_link_text
      : `扫码咨询免费试用云批宝`;

  window.Android.pPrintText(msg);
}

  // 走纸 & 切纸
  window.Android.pPrintText("\n");
  window.Android.pCutPaper(66, 50);
  apis.print_history();
}


function padEnd(str, length) {
	while (str.length < length) {
		str += " ";
	}
	return str;
}

// 删除调出暂存
export function delGoodsStoreCountLoss(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsStoreCountLossesDel`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 报损暂存修改
export function goodsUpdateLosses(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsUpdateLosses`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 调出操作
export function goodsLosses(data) {
	return axios({
		url: `${baseUrl}/syapi/goods/goodsLosses`,
		method: "post",
		// responseType:'blob',
		data
	});
}

// 生成二维码
export async function generateQRCode(data, width = 80, height = 80) {
	try {
		const options = {
			width: width,
			height: height,
			errorCorrectionLevel: "H",
			type: "image/png",
			margin: 1
		};
		const dataURL = await QRCode.toDataURL(data, options);
		return dataURL;
	} catch (error) {
		throw new Error("无法生成二维码图像: " + error.message);
	}
}

//
export async function makebase64QRCode(payQrCodeData, printDetails) {
	try {
		const base64QRCode = await generateQRCode(
			payQrCodeData ? payQrCodeData : "云批宝",
			80,
			80
		);

		printDetails.qrCodeImage = base64QRCode;
		return base64QRCode;
	} catch (error) {
		console.error("二维码生成失败:", error);
		throw new Error("二维码生成失败，无法打印");
	}
}


export  function makebase64(payQrCodeData) {

	return "data:image/png;base64,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";

}



// 等待图片加载完成
export function waitForImagesToLoad(container) {
	return new Promise(resolve => {
		const images = container.querySelectorAll("img");
		let loadedCount = 0;

		if (images.length === 0) {
			resolve();
			return;
		}

		const checkAllImagesLoaded = () => {
			loadedCount++;
			if (loadedCount === images.length) {
				resolve();
			}
		};

		images.forEach(img => {
			if (img.complete) {
				checkAllImagesLoaded();
			} else {
				img.onload = checkAllImagesLoaded;
				img.onerror = checkAllImagesLoaded;
			}
		});
	});
}

export function isFieldChecked(key, fieldName) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	let checkboxConfig = printer_info.field;
	const groupList = checkboxConfig[key];
	console.log(groupList);
	if (!groupList) {
		return false;
	}
	return groupList.some(item => item.field_name === fieldName && item.checked);
}

export function generatePrintContent1(item, transTime) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
    <div style="
      width: 80mm;
      padding: 10px 0px 0px 10px;
      box-sizing: border-box;
      font-size: 16px;
      line-height: 1.5;
      color: #000;
      background-color: #fff;
      margin: 0px 0px;
    ">
  `;

	let pay_status = "";
	if (item.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (item.yingshou == item.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (item.status == 1) {
		pay_status = "已付款";
	}
	if (
		printer_info.field.header[0].checked &&
		!printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
    `;
	}

	if (
		printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (
		!printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (isFieldChecked("header", "cashier_id")) {
		html += `
      <div style="text-align: right; font-size: 16px; margin-top: 10px;">${item.user.name}</div>
    `;
	}

	if (isFieldChecked("header", "deal_address")) {
		html += `
      <div style="text-align: center; font-size: 14px; margin-top: 10px;">
        ${userinfo.area}
      </div>
    `;
	}

	if (isFieldChecked("header", "voucher")) {
		html += `
      <div style="text-align: center; font-weight: bold; font-size: 20px; margin-top: 10px;">
        ${userinfo.dangkou_name}-销售凭证
      </div>
    `;
	}

	if (isFieldChecked("header", "maijia")) {
		html += `
      <div style="font-weight: bold; font-size: 20px; margin-top: 10px;">
        买家:${item.maijia}
      </div>
    `;
	}

	html += `
    <div style="border-top: 1px dashed #000; margin: 10px -10px;">

		</div>
  `;

	html += `
    <div style="display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 5px;">
      <div style="width: 30%;">品名</div>
      <div style="width: 23%;">数量</div>
      <div style="width: 23%;">单价</div>
      <div style="width: 23%;">货款</div>
    </div>
  `;

	html += `
    <div style="border-top: 1px dashed #000; margin: 5px -10px;">

		</div>
  `;
	let order_detail = item.order_detail;

	for (let i = 0; i < order_detail.length; i++) {
		let show_num = order_detail[i].weight
			? order_detail[i].weight
			: order_detail[i].num;
		let show_unit = order_detail[i].unit;
		let price = "";

		if (order_detail[i].huozhu_num) {
			price = "(包)" + order_detail[i].price;
		} else {
			price = order_detail[i].price;
		}

		html += `
       <div style="display: flex; justify-content: space-between; margin-bottom: 10px; font-weight: bold;">`;
		if (isFieldChecked("goods", "goods_name")) {
			html += ` <div style="width: 30%;">${i + 1}.${
				order_detail[i].goods_name
			}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}
		if (isFieldChecked("goods", "goods_shuliang")) {
			html += ` <div style="width: 23%;">${show_num}${show_unit}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}
		if (isFieldChecked("goods", "goods_danjia")) {
			html += `<div style="width: 23%;">${price}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}
		if (isFieldChecked("goods", "goods_jiage")) {
			html += `<div style="width: 23%;">${order_detail[i].goods_price}</div>`;
		} else {
			html += ` <div style="width: 30%;">${"--"}</div>`;
		}

		html += ` </div>`;

		if (isFieldChecked("goods", "huozhupici")) {
			if (order_detail[i].order_detail_pici) {
				html += `
						  <div style="font-size: 12px; margin-bottom: 5px;">${order_detail[i].order_detail_pici.huozhu_name}--${order_detail[i].order_detail_pici.pici}</div>
						`;
			}
		}
		let order_detail_fujiafei = order_detail[i].order_detail_fujiafei;
		let str = "";
		for (let j = 0; j < order_detail_fujiafei.length; j++) {
			if (order_detail_fujiafei[j].total) {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == order_detail_fujiafei[j].name
					) {
						str =
							str +
							order_detail_fujiafei[j].name +
							":" +
							order_detail_fujiafei[j].total +
							"元 ";
					}
				});
			}
		}

		if (str) {
			html += `
        <div style="margin-bottom: 5px;font-size:12px">附加费:(${str})</div>
      `;
		}

		if (isFieldChecked("goods", "goods_total")) {
			html += `
		     <div style="text-align: right; font-weight: bold; margin-bottom: 10px;">小计:${order_detail[i].total_price}元</div>
		  `;
		}
	}
	let youhui = "";
	if (item.youhui > 0) {
		youhui = "优惠:" + item.youhui + "元";
	}
	if (item.duoshou > 0) {
		youhui = "多收:" + item.duoshou + "元";
	}

	html += `
    <div style="border-top: 1px dashed #000; margin: 10px -10px;"></div>
  `;

	if (printer_info.field.settle[1].checked) {
		html += `
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">总计:${item.total_price}元</div>
    `;
	}
	if (youhui) {
		html += `
	  <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">${youhui}</div>
	`;
	}

	if (printer_info.field.settle[2].checked && item.notes) {
		html += `
      <div style="margin-top: 5px;">备注:${item.notes}</div>
    `;
	}

	if (printer_info.field.settle[3].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">截止到${currentTime}</div>
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">赊欠总额:${item.sheqian}元</div>
    `;
	}

	if (printer_info.field.settle[4].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">开单时间:${item.add_time}</div>
    `;
	}

	if (printer_info.field.settle[5].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">打印时间:${currentTime}</div>
    `;
	}
	let pay_str = "";
	pay_str = pay_str + (item.cash_num ? " 现金:" + item.cash_num : "");
	pay_str = pay_str + (item.wepay_num ? " 微信:" + item.wepay_num : "");
	pay_str = pay_str + (item.alipay_num ? " 支付宝:" + item.alipay_num : "");
	pay_str = pay_str + (item.union_num ? " 银联:" + item.union_num : "");
	pay_str = pay_str + (item.other_num ? " 其他:" + item.other_num : "");
	if (printer_info.field.pay[0].checked && pay_str) {
		html += `
      <div style="margin-top: 5px;">支付方式:${pay_str}</div>
    `;
	}

	if (printer_info.field.other[0].checked) {
		html += `
      <div style="margin-top: 5px;">档口电话:${userinfo.dangkou_phone}</div>
    `;
	}

	if (printer_info.field.other[1].checked) {
		html += `
      <div style="margin-top: 5px;">档口地址:${userinfo.dangkou_address}</div>
    `;
	}

	if (printer_info.field.other[2].checked && printer_info.shoukuan_link) {
		html += `
      <div style="text-align: center; margin: 15px 0;">
        <img src="${item.qrCodeImage}" alt="支付二维码" style="width: 150px; height: 150px;" />
        <div style="margin-top: 5px;">扫描二维码向${userinfo.dangkou_name}付款</div>
      </div>
    `;
	}

	html += `
	<div style="display: flex; align-items: center; margin-top: 15px; padding-right: 4px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 50px; margin-right: 4px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 13px; margin-top: 3px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;

	html += `</div>`;

	return html;
}

export function generatePrintContent1_(
	details,
	transTime,
	print_huozhu_chaifen = 0
) {

	let printer_info = JSON.parse(localStorage.getItem("printer_info"));

	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		width: 80mm;
		padding: 10px 0px 0px 10px;
		box-sizing: border-box;
		font-size: 16px;
		line-height: 1.5;
		color: #000;
		background-color: #fff;
		margin: 0px 0px;
	">
`;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (details.status == 1) {
		pay_status = "已付款";
	}

	if (isFieldChecked("header", "order_status")) {
		html += `
		<div data-v-25fecb1b="" style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
	`;
	}

	html += ` <div style="text-align: right; margin-bottom: 4px; font-weight: bold; margin-bottom: 20px; font-size: 20px;"> `;
	if (isFieldChecked("header", "cashier_id")) {
		html += `${details.user.name || "系统操作员A"} `;
	}

	if (isFieldChecked("header", "piao_num")) {
		html += `${details.piao_num || "009"} `;
	}

	html += `</div>`;

	if (isFieldChecked("header", "deal_address")) {
		html += `
		<div style="text-align: center; font-size: 14px;">
			${userinfo.area}
		</div>
	`;
	}
	if (isFieldChecked("header", "voucher")) {
		html += `
		<div style="text-align: center; font-weight: bold; font-size: 20px; margin-bottom: 4px;">
			${userinfo.dangkou_name}-销售凭证
		</div>
	`;
	}
	if (isFieldChecked("header", "maijia")) {
		html += `
		<div style="margin-bottom: 2px; font-weight: bold; font-size: 20px;">
			买家:${details.maijia || "临时买家"}
		</div>
	`;
	}

	// 货品列表标题

html += `
<div style="display: flex; border-bottom: 1px dashed #000; margin-bottom: 5px; font-weight: bold;">
  <div style="flex: 3;">品名</div>
  <div style="flex: 2; text-align: right;">数量</div>
  <div style="flex: 2; text-align: right;">单价</div>
  <div style="flex: 2; text-align: right;">货款</div>
</div>
`;

	details.order_detail.forEach((product, index) => {
			 html += `
				  <div style="display: flex; margin-bottom: 5px;">
				    <div style="flex: 3;">
				      ${index + 1}. ${
				        isFieldChecked("goods", "goods_name")
				          ? product.goods_name || "海南大香蕉"
				          : "--"
				      }
				    </div>
				    <div style="flex: 2; text-align: right;">
				      ${
				        isFieldChecked("goods", "goods_shuliang")
				          ? `${product.num || "1"}${product.unit || "公斤"}`
				          : "--"
				      }
				    </div>
				    <div style="flex: 2; text-align: right;">
				      ${isFieldChecked("goods", "goods_danjia") ? product.price || "8" : "--"}
				    </div>
				    <div style="flex: 2; text-align: right;">
				      ${
				        isFieldChecked("goods", "goods_jiage")
				          ? product.goods_price || "8.80"
				          : "--"
				      }
				    </div>
				  </div>
				  `;

		// 货主批次
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {
				html += `
				<div style="margin-bottom: 5px;">
					${product.order_detail_pici.huozhu.name || "张三"}-${product.order_detail_pici
					.pici || "9999"}
				</div>
				`;
			}
		}

		// 附加费
		html += `<div style="margin-bottom: 5px;">`;
		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html += `<span>附加费: (${item.field_name}:6元)</span> `;
				}
			});
		} else if (product.order_detail_fujiafei) {
			html += `<span>附加费: (`;
			product.order_detail_fujiafei.forEach((itemj, idx) => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == itemj.name
					) {
						html += `${item.field_name}:${itemj.total}元${
							idx < product.order_detail_fujiafei.length - 1 ? ", " : ""
						}`;
					}
				});
			});
			html += `)</span>`;
		}
		html += `</div>`;

		// 小计
		if (isFieldChecked("goods", "goods_total")) {
			html += `
			<div style="text-align: right; font-weight: bold; margin-bottom: 5px;">
				小计:${product.total_price || "88"}元
			</div>
			`;
		}
	});

	html += `<hr style="border-top: 1px dashed #000; margin: 10px 0;" />`;

	// 总件数
	if (isFieldChecked("goods", "goods_num")) {
		html += `
		<div style="font-weight: bold; font-size: 18px;">总件数:${details.order_detail
			.length || "3"}件</div>
		`;
	}

	// 总金额
	if (isFieldChecked("settle", "total_price")) {
		let youhui = "";
		if (details.youhui > 0) {
			youhui = " 优惠:" + details.youhui + "元";
		}
		if (details.duoshou > 0) {
			youhui = "多收:" + details.duoshou + "元";
		}

		if (details.huankuan) {
			html += `
				<div style="font-weight: bold; font-size: 18px;">总计:${details.yingshou +
					details.shishou}元</div>
			`;
			html += `
				<div style="font-weight: bold; font-size: 18px;">本次还款:${details.huankuan.money}元</div>
			`;
			if (details.huan > details.huankuan.money) {
				html += `<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan}元</div>`;
			}
			// 确保始终显示下欠
			html += `
				<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou}元</div>
			`;
		} else {
			html += `
				<div style="font-weight: bold; font-size: 18px;">总计:${details.total_price ||
					"8"}元</div>
			`;
			if (youhui) {
				html += `
					<div style="font-weight: bold; font-size: 18px;">${youhui}</div>
				`;
			}
			if (details.huan) {
				html += `
					<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan}元</div>
				`;
			}

			html += `
				<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou ||
					"0"}元</div>
			`;

			if (print_huozhu_chaifen == 1 && pay_status !== "赊欠") {
				html += `
					<div style="font-weight: bold; font-size: 18px;">实收:${details.shishou ||
						"8"}元</div>
				`;
			}
		}
	}

	// 支付方式信息
	let pay_str = "";
	pay_str = pay_str + (details.cash_num ? " 现金:" + details.cash_num : "");
	pay_str = pay_str + (details.wepay_num ? " 微信:" + details.wepay_num : "");
	pay_str =
		pay_str + (details.alipay_num ? " 支付宝:" + details.alipay_num : "");
	pay_str = pay_str + (details.union_num ? " 银联:" + details.union_num : "");
	pay_str = pay_str + (details.other_num ? " 其他:" + details.other_num : "");

	if (isFieldChecked("pay", "zhifufangshi") && pay_str) {
		html += `
		<div style="margin-bottom: 4px;">支付方式:${pay_str}</div>
		`;
	}

	// 二维码
	if (isFieldChecked("other", "pay_qr_code")) {
	  const msg =
	    printer_info.shoukuan_link_text.toString().trim()
	      ? printer_info.shoukuan_link_text
	      : `扫码咨询免费试用云批宝`;

	  html += `
	    <div style="text-align: center; margin: 10px 0;">
	      <img src="${details.qrCodeImage}" alt="二维码" style="width: 150px; height: 150px;" />
	      <br />
	      <div>${msg}</div>
	    </div>
	  `;
	}

	// printer_info

	// 备注信息
	if (isFieldChecked("settle", "notes")) {
		html += `
		<div style="margin-bottom: 4px;">备注:${details.notes || "备注信息"}</div>
		`;
	}

	// 赊欠信息
	if (isFieldChecked("settle", "sheqian") && details.sheqian > 0) {
		html += `
		<div style="margin-bottom: 4px;">
			截止到:${transTime(new Date().getTime())}
			<br />
			<span style="font-weight:bold;font-size:18px">累计赊欠:${details.sheqian ||
				"888"}元</span>
		</div>
		`;
	}

	// 时间信息
	if (isFieldChecked("settle", "add_time")) {
		html += `
		<div style="margin-bottom: 4px;">开单时间:${details.add_time ||
			"2025-3-3 11:30:30"}</div>
		`;
	}

	if (isFieldChecked("settle", "print_time")) {
		html += `
		<div style="margin-bottom: 4px;">打印时间:${transTime(
			new Date().getTime()
		)}</div>
		`;
	}

	// 联系信息
	if (isFieldChecked("other", "mobile") && userinfo.dangkou_phone) {
		html += `
		<div style="margin-bottom: 4px;">档口电话:${userinfo.dangkou_phone ||
			"17720498851"}</div>
		`;
	}

	if (isFieldChecked("other", "address") && userinfo.dangkou_address) {
		html += `
		<div style="margin-bottom: 4px;">档口地址:${userinfo.dangkou_address}</div>
		`;
	}

	// 免责声明
	html += `
	<div style="margin-top: 10px;">${details.disclaimer ||
		"以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。"}</div>
	`;

	html += `</div>`;

	return html;
}

export function generatePrintContent2(item, transTime) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
    <div style="
      width: 80mm;
       padding: 10px 0px 0px 10px;
      box-sizing: border-box;
      font-size: 16px;
      line-height: 1.5;
      color: #000;
      background-color: #fff;
      margin: 0px 0px;
    ">
  `;
	let pay_status = "";

	if (item.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (item.yingshou == item.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (item.status == 1) {
		pay_status = "已付款";
	}

	if (
		printer_info.field.header[0].checked &&
		!printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
    `;
	}

	if (
		printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (
		!printer_info.field.header[0].checked &&
		printer_info.field.header[1].checked
	) {
		html += `
      <div style="text-align: right; font-weight: bold; font-size: 20px;">${item.piao_num}</div>
    `;
	}

	if (printer_info.field.header[2].checked) {
		html += `
      <div style="text-align: right; font-size: 16px; margin-top: 10px;">${item.user.name}</div>
    `;
	}

	if (printer_info.field.header[3].checked) {
		html += `
      <div style="text-align: center; font-size: 14px; margin-top: 10px;">
        ${userinfo.area}
      </div>
    `;
	}

	if (printer_info.field.header[4].checked) {
		html += `
      <div style="text-align: center; font-weight: bold; font-size: 20px; margin-top: 10px;">
        ${userinfo.dangkou_name}-销售凭证
      </div>
    `;
	}

	if (printer_info.field.header[5].checked) {
		html += `
      <div style="font-weight: bold; font-size: 20px; margin-top: 10px;">
        买家:${item.maijia}
      </div>
    `;
	}

	html += `
    <div style=" font-size: 18px; text-align: center; margin: 15px 0 10px 0;">
      -------------订单明细---------------
    </div>
  `;

	item.order_detail.forEach((item_detail, index) => {
		let headerText = "";
		if (isFieldChecked("goods", "goods_name")) {
			headerText += index + 1 + "." + item_detail.name;
		}
		if (isFieldChecked("goods", "huozhupici")) {
			if (item_detail.order_detail_pici) {
				var huozhuName = "";
				if (
					item_detail.order_detail_pici.huozhu_name !== undefined &&
					item_detail.order_detail_pici.huozhu_name !== null
				) {
					huozhuName = item_detail.order_detail_pici.huozhu_name;
				}

				var piciValue = "";
				if (
					item_detail.order_detail_pici.pici !== undefined &&
					item_detail.order_detail_pici.pici !== null
				) {
					piciValue = item_detail.order_detail_pici.pici;
				}

				headerText += "(" + huozhuName + "-" + piciValue + ")";
			}
		}
		if (isFieldChecked("goods", "goods_total")) {
			headerText += "小计:" + item_detail.goods_price + "元       ";
		}

		if (headerText) {
			html += `
      <div style="font-weight: bold; margin-bottom: 10px;">
        ${headerText}
      </div>
    `;
		}

		let enabledGoodsFields = [];

		if (isFieldChecked("goods", "goods_shuliang")) {
			if (item.unit == "公斤" || item.unit == "斤") {
				enabledGoodsFields.push(
					"重量:" + item_detail.weight + item_detail.unit
				);
			} else {
				enabledGoodsFields.push("数量:" + item_detail.num + item_detail.unit);
			}
		}

		if (printer_info.field.goods[3].checked) {
			if (item_detail.huozhu_num > 0) {
				enabledGoodsFields.push("单价:(包)" + item_detail.price);
			} else {
				enabledGoodsFields.push("单价:" + item_detail.price);
			}
		}

		if (printer_info.field.goods[4].checked) {
			enabledGoodsFields.push("货款:" + item_detail.goods_price);
		}
		console.log("item_detail", item_detail);
		if (item_detail.order_detail_fujiafei instanceof Array) {
			item_detail.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == itemj.name
					) {
						enabledGoodsFields.push(`${item.field_name}:` + itemj.total + `元`);
					}
				});
			});
		}
		const padEnd = (str, length) => {
			if (str.length >= length) return str;
			return str + " ".repeat(length - str.length);
		};

		if (enabledGoodsFields.length > 0) {
			const rowCount = Math.ceil(enabledGoodsFields.length / 3);

			for (let i = 0; i < rowCount; i++) {
				let line = "";

				const leftIndex = i * 3;
				const centerIndex = i * 3 + 1;
				const rightIndex = i * 3 + 2;

				if (leftIndex < enabledGoodsFields.length) {
					line += padEnd(enabledGoodsFields[leftIndex], 10);
				} else {
					line += padEnd("", 10);
				}

				if (centerIndex < enabledGoodsFields.length) {
					line += padEnd(enabledGoodsFields[centerIndex], 12);
				} else {
					line += padEnd("", 12);
				}

				if (rightIndex < enabledGoodsFields.length) {
					line += enabledGoodsFields[rightIndex];
				}

				html += `<div style="margin-bottom: 5px;">${line}</div>`;
			}
		}
	});

	let youhui = "";
	if (item.youhui > 0) {
		youhui = "优惠:" + item.youhui + "元";
	}
	if (item.duoshou > 0) {
		youhui = "多收:" + item.duoshou + "元";
	}

	html += `
    <div style="border-top: 1px dashed #000; margin: 15px -10px 10px -10px;"></div>
  `;

	if (printer_info.field.settle[1].checked) {
		html += `
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">总计:${item.total_price}元</div>
    `;
	}
	if (youhui) {
		html += `
	    <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">${youhui}</div>
	  `;
	}

	if (printer_info.field.settle[2].checked && item.notes) {
		html += `
      <div style="margin-top: 5px;">备注:${item.notes}</div>
    `;
	}
	console.log("item", item);
	if (printer_info.field.settle[3].checked && item.sheqian) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">开单时间:${item.creditDate}</div>
      <div style="margin-top: 5px;">截止到:${currentTime}</div>
      <div style="font-weight: bold; font-size: 18px; margin-top: 5px;">赊欠总额:${item.sheqian}元</div>
    `;
	}

	if (printer_info.field.settle[4].checked) {
		const currentTime = transTime
			? transTime(new Date().getTime())
			: new Date().toLocaleString();
		html += `
      <div style="margin-top: 5px;">打印时间:${currentTime}</div>
    `;
	}
	let pay_str = "";
	pay_str = pay_str + (item.cash_num ? " 现金:" + item.cash_num : "");
	pay_str = pay_str + (item.wepay_num ? " 微信:" + item.wepay_num : "");
	pay_str = pay_str + (item.alipay_num ? " 支付宝:" + item.alipay_num : "");
	pay_str = pay_str + (item.union_num ? " 银联:" + item.union_num : "");
	pay_str = pay_str + (item.other_num ? " 其他:" + item.other_num : "");

	if (printer_info.field.pay[0].checked && pay_str) {
		html += `
      <div style="margin-top: 5px;">支付方式:${pay_str}</div>
    `;
	}

	if (printer_info.field.other[0].checked) {
		html += `
      <div style="margin-top: 5px;">档口电话:${userinfo.dangkou_phone}</div>
    `;
	}

	if (printer_info.field.other[1].checked) {
		html += `
      <div style="margin-top: 5px;">档口地址:${userinfo.dangkou_address}</div>
    `;
	}
if (printer_info.field.other[2].checked) {
  const msg =
    printer_info.shoukuan_link_text.toString().trim()
      ? printer_info.shoukuan_link_text
      : `扫码咨询免费试用云批宝`;

  html += `
    <div style="text-align: center; margin: 15px 0;">
      <img src="${item.qrCodeImage}" alt="支付二维码" style="width: 150px; height: 150px;" />
      <div style="margin-top: 5px;">${msg}</div>
    </div>
  `;
}

	if (printer_info.field.other[1].checked) {
		html += `
		<div style="display: flex; align-items: center; margin-top: 15px; padding-right: 4px;">
			<div style="flex: 0 0 auto; margin-right: 8px;">
					<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
			</div>
			<div style="width: 2px; background-color: rgb(72, 208, 102); height: 50px; margin-right: 4px;"></div>
			<div style="flex: 1;">
				<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
				<div style="color: rgb(254, 159, 76); font-size: 13px; margin-top: 3px;">免费试用欢迎咨询电话: 400-765-6785</div>
			</div>
		</div>
		`;
	}

	html += `
	</div>
	`;

	return html;
}

//

export function generatePrintContent3(
	details,
	transTime,
	print_huozhu_chaifen = 0,
	type=0
) {


	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		width: 80mm;
		 padding: 10px 0px 0px 10px;
		box-sizing: border-box;
		font-size: 16px;
		line-height: 1.5;
		color: #000;
		background-color: #fff;
		margin: 0px 0px;
	">
`;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠";
		}
	}
	if (details.status == 1) {
		pay_status = "已付款";
	}

	if (isFieldChecked("header", "order_status")) {
		html += `
		<div data-v-25fecb1b="" style="float: left; font-weight: bold; font-size: 20px;">${pay_status}</div>
	`;
	}
	html += ` <div style="text-align: right; margin-bottom: 4px; font-weight: bold; margin-bottom: 20px; font-size: 20px;"> `;
	if (isFieldChecked("header", "cashier_id")) {
		html += `${details.user.name || "系统操作员A"} `;
	}

	if (isFieldChecked("header", "piao_num")) {
		html += `${details.piao_num || "009"} `;
	}

	html += `</div>`;

	if (isFieldChecked("header", "deal_address")) {
		html += `
		<div style="text-align: center; font-size: 14px;">
			${userinfo.area}
		</div>
	`;
	}
	if (isFieldChecked("header", "voucher")) {
		html += `
		<div style="text-align: center; font-weight: bold; font-size: 20px; margin-bottom: 4px;">
			${userinfo.dangkou_name}-销售凭证
		</div>
	`;
	}
	if (isFieldChecked("header", "maijia")) {
		html += `
		<div style="margin-bottom: 2px; font-weight: bold; font-size: 20px;">
			买家:${details.maijia || "临时买家"}
		</div>
	`;
	}

	details.order_detail.forEach((product, index) => {
		let productLeft = "";
		let productRight = "";

		if (isFieldChecked("goods", "goods_name")) {
			productLeft = `${index + 1}.${product.goods_name || "海南大香蕉"}`;
		}
		// console.log("product.order.detail.pici",product.order_detail_pici)
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {
				var huozhuName = "张三";
				if (
					product.order_detail_pici.huozhu_name !== undefined &&
					product.order_detail_pici.huozhu_name !== null
				) {
					huozhuName = product.order_detail_pici.huozhu_name;
				}

				var piciDisplay = "-999";
				if (
					product.order_detail_pici.pici !== undefined &&
					product.order_detail_pici.pici !== null
				) {
					piciDisplay = -product.order_detail_pici.pici;
				}

				productLeft = productLeft + `  ${huozhuName}${piciDisplay}`;
			}
		}

		if (isFieldChecked("goods", "goods_total")) {
			productRight = `小计:${product.total_price || "8.8"}元`;
		}

		if (productLeft || productRight) {
			html += `
			<div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: bold;">
				<div>${productLeft}</div>
				<div>${productRight}</div>
			</div>
		`;
		}

		html += `
		<table border="1" style="width: 100%; border-collapse: collapse; margin-bottom: 5px; border: 0.6px solid black; font-size: 16px;">
			<tr>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">件数</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">重量</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">单价</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black;">货款</th>
			</tr>
			<tr>
				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
				    ${
				        (() => {
				            const raw = (product.show_num_weight || '').trim();
				            let numPart = '';
				            let weightPart = '';

				            if (raw) {
				                if (raw.includes('/')) {
				                    const parts = raw.split('/', 2).map(s => s.trim());
				                    numPart = parts[0] || '';
				                    weightPart = parts[1] || '';
				                } else {
				                    // 只有一段：含「公」或「斤」視為重量，否則視為數量
				                    if (raw.includes('公') || raw.includes('斤')) {
				                        weightPart = raw;
				                    } else {
				                        numPart = raw;
				                    }
				                }
				            }

				            return isFieldChecked("goods", "goods_shuliang")
				                ? (numPart || "——")
				                : "——";
				        })()
				    }
				</td>

				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
				    ${
				        (() => {
				            const raw = (product.show_num_weight || '').trim();
				            let numPart = '';
				            let weightPart = '';

				            if (raw) {
				                if (raw.includes('/')) {
				                    const parts = raw.split('/', 2).map(s => s.trim());
				                    numPart = parts[0] || '';
				                    weightPart = parts[1] || '';
				                } else {
				                    if (raw.includes('公') || raw.includes('斤')) {
				                        weightPart = raw;
				                    } else {
				                        numPart = raw;
				                    }
				                }
				            }

				            return weightPart || "——";
				        })()
				    }
				</td>

				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					${
						isFieldChecked("goods", "goods_danjia")
							? product.huozhu_num > 0
								? `(包)${product.price || "8"}元/${product.unit}`
								: `${product.price || "8"}元/${product.unit}`
							: "——"
					}
				</td>
				<td style="margin-bottom: 0px; font-size: 16px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					${isFieldChecked("goods", "goods_jiage") ? product.goods_price || "88元" : "——"}
				</td>
			</tr>
			<tr>
				<td colspan="4" style="margin-bottom: 0px; font-size: 13px; line-height: 1.6; border: 0.6px solid black; text-align: center;">
					<div style="width: 80%; margin: 0 auto;">`;

		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html += `<span>` + item.field_name + `:6元</span> `;
				} else if (item.extend == "fujiafei") {
					html += `<span>` + item.field_name + `:--</span> `;
				}
			});
		} else {
			product.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						item.field_name == itemj.name
					) {
						html +=
							`<span>` + item.field_name + `:` + itemj.total + `元</span> `;
					} else if (
						item.extend == "fujiafei" &&
						item.field_name == itemj.name
					) {
						html += `<span>` + item.field_name + `:--</span> `;
					}
				});
			});
		}

		html += `</div>
				</td>
			</tr>
		</table>
	`;
	});

	html += `
	<hr style="border-top: 1px dashed #000; margin: 10px -10px;" />
`;

	html += `<br>`;
	html += `<br>`;

	if (isFieldChecked("settle", "total_price")) {
		let youhui = "";
		if (details.youhui > 0) {
			youhui = " 优惠:" + details.youhui + "元";
		}
		if (details.duoshou > 0) {
			youhui = "多收:" + details.duoshou + "元";
		}

		if (details.huankuan) {
			let pay_str_now = "";
			pay_str_now =
				pay_str_now +
				(details.huankuan.cash_num > 0
					? " 现金:" + details.huankuan.cash_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.wepay_num > 0
					? " 微信:" + details.huankuan.wepay_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.alipay_num > 0
					? " 支付宝:" + details.huankuan.alipay_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.union_num > 0
					? " 银联:" + details.huankuan.union_num
					: "");
			pay_str_now =
				pay_str_now +
				(details.huankuan.other_num > 0
					? " 其他:" + details.huankuan.other_num
					: "");

			html += `
					<div style="font-weight: bold; font-size: 18px;">总计:${details.yingshou +
						details.shishou}元</div>
				`;
			html += `
					<div style="font-weight: bold; font-size: 18px;">本次还款:${details.huankuan.money}元</div>
				`;
			if (details.huan > details.huankuan.money) {
				html += `<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan}元</div>`;
			}
			html += `
					<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou}元</div>
				`;
		} else {
			html += `
				<div style="font-weight: bold; font-size: 18px;">总计:${details.total_price ||
					"8"}元</div>
			`;
			if (youhui) {
				html += `
					<div style="font-weight: bold; font-size: 18px;">${youhui || "8"}</div>
				`;
			}
			if (details.huan) {
				html += `
							<div style="font-weight: bold; font-size: 18px;">累计还款:${details.huan ||
								"元"}元</div>
						`;
			}

			if (pay_status === "赊欠") {
				html += `
					<div style="font-weight: bold; font-size: 18px;">下欠:${details.yingshou ||
						"8"}元</div>
				`;
			} else {
				if (print_huozhu_chaifen == 1)
					html += `
					<div style="font-weight: bold; font-size: 18px;">实收:${details.shishou ||
						"8"}元</div>
				`;
			}
		}
	}

	if (isFieldChecked("other", "pay_qr_code")) {
	  const msg =
	    printer_info.shoukuan_link_text.toString().trim() || "扫码咨询免费试用云批宝";
		const qrCodeImage =
		  printer_info.shoukuan_link? details.qrCodeImage :makebase64();

	  html += `
	    <div style="text-align: right; margin: -40px 0;">
	      <img src="${qrCodeImage}" alt="二维码"
	           style="position: relative; top:-45px; width: 80px; height: 80px;" />
	      <br />
	      <a style="position: relative; top:-45px;">${msg}</a>
	    </div>
	  `;
	}

html += `</div>`;
	html += `<hr style="border-top: 1px dashed #000; margin: 5px 0;" />`;
const note = (details.notes ?details.notes: '').toString().trim();

if (isFieldChecked("settle", "notes") && note) {
  html += `
  <div style="margin-bottom: 4px;">
    备注: ${note}
    <br />`;
}

	if (isFieldChecked("settle", "sheqian") && details.sheqian > 0) {
		html +=
			`
		<div style="margin-bottom: 4px;">
			截止到:` +
			transTime(new Date().getTime()) +
			`
			<br />`;
	}

	if (isFieldChecked("settle", "sheqian") && details.sheqian > 0) {
		html += `<span style="font-weight:bold;font-size:18px">
				累计赊欠: ${details.sheqian || "88"}元</span>
				<br />`;
	}

	if (isFieldChecked("settle", "add_time")) {
		html += ` 开单时间: ${details.add_time || "2025-3-3 11:30:30"}
		<br />
		`;
	}

	if (isFieldChecked("settle", "print_time")) {
		html +=
			` 打印时间: ` +
			transTime(new Date().getTime()) +
			`
		<br />
		`;
	}

	let pay_str = "";
	pay_str = pay_str + (details.cash_num ? " 现金:" + details.cash_num : "");
	pay_str = pay_str + (details.wepay_num ? " 微信:" + details.wepay_num : "");
	pay_str =
		pay_str + (details.alipay_num ? " 支付宝:" + details.alipay_num : "");
	pay_str = pay_str + (details.union_num ? " 银联:" + details.union_num : "");
	pay_str = pay_str + (details.other_num ? " 其他:" + details.other_num : "");

	if (isFieldChecked("pay", "zhifufangshi") && pay_str) {
		html +=
			` 支付方式: ` +
			pay_str +
			`
		<br />
		`;
	}

	if (isFieldChecked("other", "mobile")) {
		html += `档口电话: ${userinfo.dangkou_phone || "17720498851"}
	`;
	}

	if (isFieldChecked("other", "address")) {
		html += `
		<br />
		档口地址: ${userinfo.dangkou_address || "武汉市新华南综合市场B10-01"}
	`;
	}

	html += `
	</div>
`;
	html += `
	<div>${details.disclaimer ||
		"以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。"}</div>
`;

if (type) {
	html += `
	<div style="display: flex; align-items: center; margin-top: 15px; padding-right: 4px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 50px; margin-right: 4px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 13px; margin-top: 3px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;
	}



	html += `
	</div>
`;

	return html;
}

//
export function generatePrintContent4(details, transTime) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		position: relative;
		width: 100%;
		height: 680px;
		overflow: visible;
	">
		<div style="
			position: absolute;
			left: 50%;
			top: 50%;
			width: 170mm;
			height: 80mm;
			padding: 5px;
			box-sizing: border-box;
			line-height: 1.1;
			transform: translate(-50%, -50%) rotate(90deg);
			transform-origin: center center;
			color: #000;
			background-color: #fff;
		">
`;

	html += `
		<div style="display: flex; justify-content: space-between; margin-bottom: 0px; font-weight: bold;"> `;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠  ";
		}
	}

	if (isFieldChecked("header", "order_status")) {
		html += `<div style="font-size: 24px;">${pay_status}</div>`;
	} else {
		html += `<div style="font-size: 24px;color:#ffffff">0000</div>`;
	}

	if (isFieldChecked("header", "deal_address")) {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center;" >${userinfo.area}</div>`;
	} else {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center; color:#ffffff"" >000</div>`;
	}

	if (details.notes && details.notes.trim() !== "") {
		html += `<div style="font-size: 14px; text-align: center; margin-bottom: 5px;">备注: ${details.notes}</div>`;
	}

	html += `<div style="text-align: right;">`;
	if (isFieldChecked("header", "cashier_id")) {
		html += `<span style="font-size: 20px;">${details.user.name ||
			"系统操作员A"}</span>`;
	} else {
		html += `<span style="font-size: 20px;color:#ffffff">00</span>`;
	}
	if (isFieldChecked("header", "piao_num")) {
		html += `<span style="font-size: 20px;">${details.piao_num ||
			"009"}</span>`;
	} else {
		html += `<span style="font-size: 20px;color:#ffffff">00</span>`;
	}
	html += `</div>`;

	html += `</div>
	`;

	if (isFieldChecked("header", "voucher")) {
		html += `
			<div style="display: flex; justify-content: center; margin-bottom: 5px; font-weight: bold;">
				<div style="font-size: 24px;">${userinfo.dangkou_name}-销售凭证</div>
			</div>
	`;
	}

	html += ``;

	details.order_detail.forEach((product, index) => {
		let productLeft = "";
		let productRight = "";

		if (isFieldChecked("goods", "goods_name")) {
			productLeft = `${index + 1}.${product.goods_name || "海南大香蕉"}`;
		}
		if (isFieldChecked("goods", "goods_jiage")) {
			productRight = `小计:${product.subtotal || "8.88元"}元`;
		}

		if (isFieldChecked("settle", "add_time")) {
			html +=
				`
			<div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: bold;">
				<div style="font-size: 24px;">买家:${details.maijia}</div>
				<div style="font-size: 15px; margin-bottom: -15px; font-weight: 400; display: flex; align-items: center;">开票日期:` +
				getGurrentTime() +
				` &nbsp;赊账日期: ${details.add_time || "2024-12-20 15:20"}</div>
			</div>`;
		} else {
			html += `
			<div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-weight: bold;">
				<div style="font-size: 24px;">买家:${details.maijia}</div>
			</div>
		`;
		}

		html += `
		<table border="1" style="width: 100%; table-layout: fixed; border-collapse: collapse; margin-bottom: 5px; border: 0.6px solid black; font-size: 16px;">
			<tr>
				<th style="width: 20%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">品名</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货主</th>
				<th style="width: 12%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">数量</th>
				<th style="width: 12%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">重量</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">单价</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货款</th>
			</tr>
			<tr>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black; word-break: break-all;">
				  ${
				    isFieldChecked("goods", "goods_name")
				      ? index + 1 + "." + (
				          product.goods_name
				            ? (product.goods_name.length > 7
				                ? product.goods_name.substring(0, 7) + "…"
				                : product.goods_name
				              )
				            : "海南大香蕉"
				        )
				      : "——"
				  }
				</th>
				 <th style="margin-bottom: 0px; font-size: 16px; line-height: 2; border: 0.6px solid black; word-break: break-all;">`;
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {
				html +=
					product.order_detail_pici.huozhu_name +
					product.order_detail_pici.pici;
			} else {
				html += "--";
			}
		} else {
			html += "--";
		}

		html += `</th><th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
    ${
        (() => {
            const raw = (product.show_num_weight || '').trim();
            let numPart = '';
            let weightPart = '';

            if (raw) {
                if (raw.includes('/')) {
                    const parts = raw.split('/', 2).map(s => s.trim());
                    numPart = parts[0] || '';
                    weightPart = parts[1] || '';
                } else {
                    // 含「公」或「斤」視為重量，否則視為數量
                    if (raw.includes('公') || raw.includes('斤')) {
                        weightPart = raw;
                    } else {
                        numPart = raw;
                    }
                }
            }

            return isFieldChecked("goods", "goods_shuliang")
                ? (numPart || "——")
                : "——";
        })()
    }
</th>

<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
    ${
        (() => {
            const raw = (product.show_num_weight || '').trim();
            let numPart = '';
            let weightPart = '';

            if (raw) {
                if (raw.includes('/')) {
                    const parts = raw.split('/', 2).map(s => s.trim());
                    numPart = parts[0] || '';
                    weightPart = parts[1] || '';
                } else {
                    if (raw.includes('公') || raw.includes('斤')) {
                        weightPart = raw;
                    } else {
                        numPart = raw;
                    }
                }
            }

            return weightPart || "——";
        })()
    }
</th>


				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${
						isFieldChecked("goods", "goods_danjia")
							? product.huozhu_num > 0
								? "(包)" + (product.price || "8元") + "/公斤"
								: (product.price || "8元") + "/公斤"
							: "——"
					}
				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${isFieldChecked("goods", "goods_jiage") ? product.goods_price || "——" : "——"}
				</th>
			</tr>
			<tr>
				<th colspan="4" style="margin-bottom: 0px; font-size: 13px; line-height: 2.5; border: 0.6px solid black; text-align: left; padding-left: 5px;">
					<div style="display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%;">`;

		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:6元</span> `;
				} else if (item.extend == "fujiafei") {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:--</span> `;
				}
			});
		} else {
			product.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:` +
							itemj.total +
							`元</span> `;
					} else if (
						item.extend == "fujiafei" &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:--</span> `;
					}
				});
			});
		}

		html += `</div>
				</th>
				<th colspan="2" style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					<div>
						<span>小计:${
							isFieldChecked("goods", "goods_total")
								? product.total_price || "88"
								: "——"
						}元</span>
					</div>
				</th>
			</tr>
		</table>
	`;
	});

	let hasNotes =
		isFieldChecked("settle", "notes") &&
		details.notes &&
		details.notes.trim() !== "";
	let hasSalesperson =
		details.user && details.user.name && details.user.name.trim() !== "";
	let hasPhone =
		isFieldChecked("other", "mobile") &&
		userinfo.dangkou_phone &&
		userinfo.dangkou_phone.trim() !== "";
	let hasAddress =
		isFieldChecked("other", "address") &&
		userinfo.dangkou_address &&
		userinfo.dangkou_address.trim() !== "";
	let hasStatement = true;

// 二维码定位
if (isFieldChecked("other", "pay_qr_code")) {
  const msg =
    printer_info.shoukuan_link_text.toString().trim() || "扫码咨询免费试用云批宝";

	const qrCodeImage =
	  printer_info.shoukuan_link?  details.qrCodeImage:makebase64();

  html += `
    <div style="position: absolute; right: 5px; bottom: 5px; text-align: right;">
      <img src="${qrCodeImage}" alt="二维码" style="width: 60px; height: 60px;" />
      <div style="font-size: 14px; text-align: center;">${msg}</div>
    </div>
  `;
}


	let fields = [];
	if (hasNotes) fields.push({ label: "备注", value: details.notes });
	if (hasSalesperson)
		fields.push({ label: "销售员", value: details.user.name });
	if (hasPhone)
		fields.push({ label: "档口电话", value: userinfo.dangkou_phone });
	if (hasAddress)
		fields.push({ label: "档口地址", value: userinfo.dangkou_address });

	html += `<table border="1" style="width: calc(100% - 70px); table-layout: fixed; border-collapse: collapse; border: 1px solid #f5f7fa08;">`;

	// 固定的行高
	const cellHeight = "30px";

	// 生成前四个字段的2x2布局
	if (fields.length > 0) {
		// 第一行
		html += `<tr style="">`;
		if (fields.length > 0) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">${fields[0].label}: ${fields[0].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">&nbsp;</td>`;
		}
		if (fields.length > 1) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">${fields[1].label}: ${fields[1].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">&nbsp;</td>`;
		}
		html += `</tr>`;

		// 第二行
		html += `<tr>`;
		if (fields.length > 2) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">${fields[2].label}: ${fields[2].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">&nbsp;</td>`;
		}
		if (fields.length > 3) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">${fields[3].label}: ${fields[3].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #f5f7fa08; ">&nbsp;</td>`;
		}
		html += `</tr>`;
	}
	html += `
		<tr>
			<td colspan="2" style="font-size: 12px; padding: 5px; border: 1px solid #f5f7fa08; line-height: 1.2;">
				以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。
			</td>
		</tr>
	`;
	html += `</table>`;
	html += `
	<div style="display: flex; align-items: center; margin-top: 6px; padding: 0 5px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 40px; margin-right: 8px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 12px; margin-top: 2px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;

	html += `
		</div>
	</div>
	`;

	return html;
}
export function generatePrintContent5(
	details,
	transTime,
) {
	let printer_info = JSON.parse(localStorage.getItem("printer_info"));
	let userinfo = JSON.parse(localStorage.getItem("userInfo"));

	let html = `
	<div style="
		position: relative;
		width: 550px;
		margin: 0 auto;
		padding: 10px;
		box-sizing: border-box;
		background-color: #fff;
	">
`;

	html += `
		<div style="display: flex; justify-content: space-between; margin-bottom: 10px; font-weight: bold;"> `;

	let pay_status = "";
	if (details.yingshou <= 0) {
		pay_status = "已付款";
	} else {
		if (details.yingshou == details.shishou) {
			pay_status = "未付款";
		} else {
			pay_status = "赊欠  ";
		}
	}

	if (isFieldChecked("header", "order_status")) {
		html += `<div style="font-size: 24px;">${pay_status}</div>`;
	} else {
		html += `<div style="font-size: 24px;color:#ffffff">0000</div>`;
	}

	if (isFieldChecked("header", "deal_address")) {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center;" >${userinfo.area}</div>`;
	} else {
		html += `<div style="font-size: 16px; font-weight: 200; text-align: center; color:#ffffff"" >000</div>`;
	}

	if (isFieldChecked("header", "cashier_id")) {
		html += `<div style="text-align: right;">
			<span style="font-size: 20px;">${details.user.name || "系统操作员A"}</span>`;

		if (isFieldChecked("header", "piao_num")) {
			html += `<span style="font-size: 20px;">${details.piao_num || "009"}</span>`;
		}
		html += `</div>`;
	} else if (isFieldChecked("header", "piao_num")) {
		html += `<div style="text-align: right;">
			<span style="font-size: 20px;">${details.piao_num || "009"}</span>
		</div>`;
	} else {
		html += `<div style="text-align: right;">
			<span style="font-size: 20px;color:#ffffff">00</span>
		</div>`;
	}

	html += `</div>`;

	if (isFieldChecked("header", "voucher")) {
		html += `
			<div style="display: flex; justify-content: center; margin-bottom: 10px; font-weight: bold;">
				<div style="font-size: 24px;">${userinfo.dangkou_name}-销售凭证</div>
			</div>
		`;
	}

	if (details.notes && details.notes.trim() !== "") {
		html += `<div style="font-size: 14px; text-align: center; margin-bottom: 10px;">备注: ${details.notes}</div>`;
	}

	details.order_detail.forEach((product, index) => {
		if (isFieldChecked("settle", "add_time")) {
			html += `
				<div style="margin-bottom: 10px;">
					<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
						<div style="font-size: 22px; font-weight: bold; white-space: nowrap;">买家:${details.maijia}</div>
					</div>
					<div style="display: flex; justify-content: flex-end; font-size: 13px; margin-bottom: 5px;">
						<div style="white-space: nowrap;">开票日期:${getGurrentTime()}</div>
						<div style="white-space: nowrap; margin-left: 10px;">赊账日期:${details.add_time || "2024-12-20 15:20"}</div>
					</div>
				</div>
			`;
		} else {
			html += `
				<div style="margin-bottom: 10px;">
					<div style="font-size: 22px; font-weight: bold;">买家:${details.maijia}</div>
				</div>
			`;
		}

		html += `
		<table border="1" style="width: 100%; table-layout: fixed; border-collapse: collapse; margin-bottom: 10px; border: 0.6px solid black; font-size: 16px;">
			<tr>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">品名</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货主</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">数量</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">重量</th>
				<th style="width: 14%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">单价</th>
				<th style="width: 16%; margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">货款</th>
			</tr>
			<tr>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black; word-break: break-all;">
					${
						isFieldChecked("goods", "goods_name")
							? index + 1 + "." + (product.goods_name || "海南大香蕉")
							: "--"
					}
				</th>
				 <th style="margin-bottom: 0px; font-size: 16px; line-height: 2; border: 0.6px solid black; word-break: break-all;">`;
		if (isFieldChecked("goods", "huozhupici")) {
			if (product.order_detail_pici) {

				html +=
					product.order_detail_pici.huozhu_name +
					product.order_detail_pici.pici;
			} else {
				html += "--";
			}
		} else {
			html += "--";
		}

		html += `</th><th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${isFieldChecked("goods", "goods_shuliang") ? product.num || "--" : "--"}

				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid;">
					${product.weight || "--"}
				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${
						isFieldChecked("goods", "goods_danjia")
							? product.huozhu_num > 0
								? "(包)" + (product.price || "8元") + "/公斤"
								: (product.price || "8元") + "/公斤"
							: "--"
					}
				</th>
				<th style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					${isFieldChecked("goods", "goods_jiage") ? product.goods_price || "--" : "--"}
				</th>
			</tr>
			<tr>
				<th colspan="4" style="margin-bottom: 0px; font-size: 13px; line-height: 2.5; border: 0.6px solid black; text-align: left; padding-left: 5px;">
					<div style="display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%;">`;

		if (product.order_detail_fujiafei == "测试") {
			printer_info.field.goods.forEach(item => {
				if (item.extend == "fujiafei" && item.checked) {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:6元</span> `;
				} else if (item.extend == "fujiafei") {
					html +=
						`<span style="margin-right: 15px; white-space: nowrap;">` +
						item.field_name +
						`:--</span> `;
				}
			});
		} else {
			product.order_detail_fujiafei.forEach(itemj => {
				printer_info.field.goods.forEach(item => {
					if (
						item.extend == "fujiafei" &&
						item.checked &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:` +
							itemj.total +
							`元</span> `;
					} else if (
						item.extend == "fujiafei" &&
						itemj.name == item.field_name
					) {
						html +=
							`<span style="margin-right: 15px; white-space: nowrap;">` +
							item.field_name +
							`:--</span> `;
					}
				});
			});
		}

		html += `</div>
				</th>
				<th colspan="2" style="margin-bottom: 0px; font-size: 16px; line-height: 2.5; border: 0.6px solid black;">
					<div>
						<span>小计:${
							isFieldChecked("goods", "goods_total")
								? product.total_price || "88"
								: "--"
						}元</span>
					</div>
				</th>
			</tr>
		</table>
	`;
	});

	let hasNotes =
		isFieldChecked("settle", "notes") &&
		details.notes &&
		details.notes.trim() !== "";
	let hasSalesperson =
		details.user && details.user.name && details.user.name.trim() !== "";
	let hasPhone =
		isFieldChecked("other", "mobile") &&
		userinfo.dangkou_phone &&
		userinfo.dangkou_phone.trim() !== "";
	let hasAddress =
		isFieldChecked("other", "address") &&
		userinfo.dangkou_address &&
		userinfo.dangkou_address.trim() !== "";
	let hasStatement = true;

	let fields = [];
	if (hasNotes) fields.push({ label: "备注", value: details.notes });
	if (hasSalesperson)
		fields.push({ label: "销售员", value: details.user.name });
	if (hasPhone)
		fields.push({ label: "档口电话", value: userinfo.dangkou_phone });
	if (hasAddress)
		fields.push({ label: "档口地址", value: userinfo.dangkou_address });

	let tableWidth = "calc(100% - 70px)";

	if (isFieldChecked("other", "pay_qr_code")) {
		html += `
		<div style="position: relative; margin-bottom: 10px; width: 100%;">
			<div style="position: absolute; right: 0; bottom: 0; text-align: right; z-index: 10; padding: 5px;">
				<img src="${details.qrCodeImage}" alt="二维码" style="width: 60px; height: 60px; display: block;" />
				<div style="font-size: 14px; text-align: center;">扫码付款</div>
			</div>
		`;
	} else {
		tableWidth = "100%";
		html += `<div style="position: relative; margin-bottom: 10px; width: 100%;">`;
	}

	html += `<table border="1" style="width: ${tableWidth}; table-layout: fixed; border-collapse: collapse; border: 1px solid #000;">`;

	const cellHeight = "30px";

	if (fields.length > 0) {
		html += `<tr style="height: ${cellHeight};">`;
		if (fields.length > 0) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[0].label}: ${fields[0].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		if (fields.length > 1) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[1].label}: ${fields[1].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		html += `</tr>`;

		html += `<tr style="height: ${cellHeight};">`;
		if (fields.length > 2) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[2].label}: ${fields[2].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		if (fields.length > 3) {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">${fields[3].label}: ${fields[3].value}</td>`;
		} else {
			html += `<td style="font-size: 14px; padding: 5px; border: 1px solid #000; height: ${cellHeight};">&nbsp;</td>`;
		}
		html += `</tr>`;
	}
	html += `
		<tr>
			<td colspan="2" style="font-size: 12px; padding: 5px; border: 1px solid #000; line-height: 1.2;">
				以上食用农产品均履行进货检查法定程序索证索票齐全销售者特此声明。
			</td>
		</tr>
	`;
	html += `</table>`;

	html += `</div>`;

	html += `
	<div style="display: flex; align-items: center; margin-top: 6px; padding: 0 5px;">
		<div style="flex: 0 0 auto; margin-right: 8px;">
			<img src="../../static/logo.jpeg" alt="云批宝" style="width: 50px; height: 50px;" />
		</div>
		<div style="width: 2px; background-color: rgb(72, 208, 102); height: 40px; margin-right: 8px;"></div>
		<div style="flex: 1;">
			<div style="color: rgb(72, 208, 102); font-size: 16px;">云批宝，专业农批收银管理系统</div>
			<div style="color: rgb(254, 159, 76); font-size: 12px; margin-top: 2px;">免费试用欢迎咨询电话: 400-765-6785</div>
		</div>
	</div>
	`;

	html += `</div>`;

	return html;
}
export async function executeShare(templateType, loading, printContent) {
	const tempContainer = document.createElement("div");
	const isRotatedTemplate = templateType === 4;

	  tempContainer.style.width = isRotatedTemplate ? "80mm" : "80mm";
	tempContainer.style.padding = "0px";
	tempContainer.style.boxSizing = "border-box";
	tempContainer.style.fontSize = "12px";
	tempContainer.style.lineHeight = "1.5";
	tempContainer.style.color = "#000";
	tempContainer.style.backgroundColor = "#fff";
	tempContainer.innerHTML = printContent;
	tempContainer.style.position = "absolute";
	tempContainer.style.left = "-9999px";
	document.body.appendChild(tempContainer);
	// alert(555)
	try {
		await waitForImagesToLoad(tempContainer);
		const printCanvas = await html2canvas(tempContainer, {
			useCORS: true,
			scale: 2
		});

		const imgData = printCanvas.toDataURL("image/png");



console.log(imgData);


		const base64Data = imgData.replace(/^data:image\/png;base64,/, "");

		document.body.removeChild(tempContainer);
		window.Android.shareBase64Image(base64Data, "1.png");
		// window.Android.shareBase64Image(res.data,"1.png");
	} catch (error) {
		console.error("打印失败:", error);
		throw new Error("错误:" + error.message);
	}
}
export async function executeShare2(
  templateType,
  loading,
  printContent,
  width = 750,
  height = 500
) {
  try {
    if (loading) loading.value = true;

    const tempContainer = document.createElement("div");
    document.body.appendChild(tempContainer);

    tempContainer.style.position = "fixed";
    tempContainer.style.left = "0";
    tempContainer.style.top = "0";
    tempContainer.style.minWidth = "800px";
    tempContainer.style.minHeight = "1000px";
    tempContainer.style.padding = "0";
    tempContainer.style.margin = "0";
    tempContainer.style.boxSizing = "border-box";
    tempContainer.style.backgroundColor = "#fff";
    tempContainer.style.zIndex = "-1000";
    tempContainer.style.overflow = "visible";

    tempContainer.innerHTML = printContent;

    const centerDiv = tempContainer.querySelector('div[style*="position: absolute"][style*="left: 50%"]');
    if (centerDiv) {
      centerDiv.style.transform = "none";
      centerDiv.style.position = "relative";
      centerDiv.style.left = "auto";
      centerDiv.style.top = "auto";
      centerDiv.style.width = "550px";
      centerDiv.style.margin = "0 auto";
    }

    await new Promise(resolve => setTimeout(resolve, 500));
    await waitForImagesToLoad(tempContainer);

    const printCanvas = await html2canvas(tempContainer, {
      useCORS: true,
      scale: 1.5,
      logging: false,
      allowTaint: true,
      backgroundColor: "#fff",
      width: width || 750,
      height: height || 1000,
      onclone: (document, clone) => {
        const centerDivClone = clone.querySelector('div[style*="position: absolute"][style*="left: 50%"]');
        if (centerDivClone) {
          centerDivClone.style.transform = "none";
          centerDivClone.style.position = "relative";
          centerDivClone.style.left = "auto";
          centerDivClone.style.top = "auto";
          centerDivClone.style.width = "550px";
          centerDivClone.style.margin = "0 auto";
        }

        const qrCodeImg = clone.querySelector('img[alt="二维码"]');
        if (qrCodeImg) {
          let parent = qrCodeImg.parentElement;
          while (parent) {
            parent.style.visibility = "visible";
            parent.style.display = parent.tagName === 'DIV' ? 'block' : '';
            parent.style.zIndex = "1000";
            parent = parent.parentElement;
          }
        }

        return clone;
      }
    });

    const imgData = printCanvas.toDataURL("image/png");
    const base64Data = imgData.replace(/^data:image\/png;base64,/, "");
    console.log(base64Data);
    document.body.removeChild(tempContainer);

    window.Android.shareBase64Image(base64Data, "1.png");
  } catch (error) {
    console.error("打印失败:", error);
    throw new Error("错误:" + error.message);
  }
}
export async function executePrint(templateType, loading, printContent) {
	const tempContainer = document.createElement("div");
	const isRotatedTemplate = templateType === 4;

	tempContainer.style.width = isRotatedTemplate ? "80mm" : "80mm";
	tempContainer.style.padding = "0px";
	tempContainer.style.boxSizing = "border-box";
	tempContainer.style.fontSize = "12px";
	tempContainer.style.lineHeight = "1.5";
	tempContainer.style.color = "#000";
	tempContainer.style.backgroundColor = "#fff";
	tempContainer.innerHTML = printContent;
	tempContainer.style.position = "absolute";
	tempContainer.style.left = "-9999px";
	document.body.appendChild(tempContainer);

	try {
		await waitForImagesToLoad(tempContainer);
		const printCanvas = await html2canvas(tempContainer, {
			useCORS: true,
			scale: 2
		});

		const imgData = printCanvas.toDataURL("image/png");

		const base64Data = imgData.replace(/^data:image\/png;base64,/, "");
		console.log(base64Data);
		document.body.removeChild(tempContainer);

		const printResult = window.Android.printBase64Picture(base64Data);

		setTimeout(() => {
			window.Android.pCutPaper(66, 50);
		}, 1000);

		return printResult;
	} catch (error) {
		console.error("打印失败:", error);
		throw new Error("错误:" + error.message);
	}
}

// 打印html内容
export async function executePrint2(templateType, loading, printContent) {
	const tempContainer = document.createElement("div");
	const isRotatedTemplate = templateType === 4;

	tempContainer.style.width = isRotatedTemplate ? "80mm" : "80mm";
	tempContainer.style.padding = "0px";
	tempContainer.style.boxSizing = "border-box";
	tempContainer.style.fontSize = "12px";
	tempContainer.style.lineHeight = "1.5";
	tempContainer.style.color = "#000";
	tempContainer.style.backgroundColor = "#fff";
	tempContainer.innerHTML = printContent;
	tempContainer.style.position = "absolute";
	tempContainer.style.left = "-9999px";
	document.body.appendChild(tempContainer);

	try {
		await waitForImagesToLoad(tempContainer);
		const printCanvas = await html2canvas(tempContainer, {
			useCORS: true,
			scale: 2
		});

		const imgData = printCanvas.toDataURL("image/png");
		const base64Data = imgData.replace(/^data:image\/png;base64,/, "");
		console.log(base64Data);
		document.body.removeChild(tempContainer);

		return window.Android.printBase64Picture(base64Data);
	} catch (error) {
		console.error("打印失败:", error);
		throw new Error("错误:" + error.message);
	}
}

export async function printSingleCopy(templateType, printContent) {
	try {
		await executePrint2(templateType, null, printContent);
		await new Promise(resolve => setTimeout(resolve, 1000));
		window.Android.pCutPaper(66, 50);
	} catch (error) {
		console.error("单次打印失败:", error);
		throw error;
	}
}






// WEBPACK FOOTER //
// ./src/api/index.js